/* eslint-disable eqeqeq */
<template>
  <div oncontextmenu="return false" class="post-body vx-row justify-between">
    <vx-card class="vx-col preview-edit-side" oncopy="return false" oncut="return false"
    :class="[isShowComment ? 'w-full' : reduceButton ? 'w-61' : 'w-57']">
      <div :style="{zoom: `${zoomValue}`, transform: 'translateX(' + -xPosition + '%)'}" class="w-full justify-center vx-row">
        <div>
          <div id="layout-preview" class="pdf-separation">
            <div id="jusetsu">
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="vx-col comment-preivew-frame" id="closeCommentSiderPage" :style="isShowComment ? 'display: none': 'width: 36%'">
      <Comment @tickPart="tickPart" @showHightlightInPage="handleShowHightlightInPage" :showCommentPart="false"/>
    </vx-card>
    <div class="scrollbar" :class="[!reduceButton ? '' : 'w-573']" v-if="zoomValue.toFixed(2) > 1 && !isShowComment">
      <input class="slider" type="range" min="-100" max="100" v-model="xPosition">
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import moment from 'moment'
import {JTM, JES, JSE, JRB, JUSETSU, JUSETSU_HTML, PART_TO_ACTION} from '@/constant/parttern'
import {GET_JUSETSU_TEMPLATE, GET_PART_JUSETSU_TEMPLATE, SAVE_PART_JUSETSU_TEMPLATE, GET_KEIYAKU_BY_DOCUMENT_ID, GET_SURVEY_LINKAGE, UPDATE_BREADCRUMB} from '@/store/modules/keiyaku/actions.js'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import highlighter from '../mixins/highlighter'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import ocr from '@/mixins/ocr'
import Comment from '../views/comment/index.vue'
import { idJusetsuGeneral_l1 } from '../constant/highlight'
import { bus } from '../main'
import { SAVE_EDIT_MODE, SAVE_JES, SAVE_JRB_M007_04, SAVE_BES, SAVE_KEIYAKU, SAVE_JRB, SAVE_JLE, SAVE_JSE, SAVE_JTM } from '../store/modules/keiyaku/actions'
import base64Url from 'base64-url'
import { SET_STATE_SHOW_ZOOM_BAR, SET_DATA_SAVE_STATUS } from '@/store/modules/keiyaku/mutations'
import MusubellAgentApi from '../../src/apis/musubell_agent'
// import {JusetsuPattern1, JusetsuPattern2, JusetsuPattern3, JusetsuPattern4} from '../mock-data/ocr/index'
export default {
  mixins: [routeIfCodeNull, highlighter, utilitiesMethods, ocr],
  components: {
    Comment
  },
  data () {
    return {
      xPosition: 0,
      isShowComment: true,
      dataTochiInputs: [],
      spinnerTimer: null,
      previewLayout: null,
      documentId: null,
      base64DocumentId: null,
      arrText: ['ーーー', 'ーーーーーーーーーーーーーーーーーーーーー', 'ーーーーーーーーーーーーーーーーーー', 'ーーーーーーーーーーーー', 'ーーーーーーーーーーーーーー', 'ーーーーーーーーーーー', 'ーーーーーーーーー', 'ーーーーーーーー', 'ーーーーーー', 'ーーーーー', 'ーーーーーーーーーーーーーーーーーーーーーーーーーーーーー', 'ーーーー', 'ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー ー', 'ーーーーーーーー', 'ーーーーーーーーー', 'ーーーーーーーーーーーーーーー'],
      templateValidation: {
        'jtm':{
          kainushi: {
            elements: [
              {
                kainushi: {
                  warning: (idx) => {
                    const inputEl1 = $('div[name="kainushi"]')
                    return !$(inputEl1[idx]).html()
                  }
                }
              }
            ]
          },
          urinushi: {
            elements: [
              {
                urinushi: {
                  warning: (idx) => {
                    const inputEl1 = $('div[name="urinushi"]')
                    return !$(inputEl1[idx]).html()
                  }
                }
              }
            ]
          },
          urinushi_gyosha_menkyo_nengappi: {
            patterns: ['jtm-02'],
            warning: () => {
              const momentTime = moment($('span[name="urinushi_gyosha_menkyo_nengappi_hidden"]').html(), 'YYYY-MM-DD')
              return !$('span[name="urinushi_gyosha_menkyo_nengappi_hidden"]').html() || (this.isNinetyDayAfterFiveYears(momentTime) && !this.isFiveYear(momentTime))
            }
          },
          torihikishi1_shimei: {
            patterns: ['jtm-02'],
            warning: true
          },
          torihikishi1_denwabango: {
            patterns: ['jtm-02'],
            warning: true
          },
          torihikishi1_jimusho_jusho: {
            patterns: ['jtm-02'],
            warning: () => {
              if(!$('div[name="torihikishi1_jimusho_jusho"]').html()) {
                $('td[name="torihikishi1_jimusho_jusho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          urinushi_gyosha_daihyoshayakusho: {
            patterns: ['jtm-02'],
            warning: true
          },
          urinushi_gyosha_shutaru_jimusho_shozaichi: {
            patterns: ['jtm-02'],
            warning: () => {
              if(!$('div[name="urinushi_gyosha_shutaru_jimusho_shozaichi"]').html()) {
                $('td[name="urinushi_gyosha_shutaru_jimusho_shozaichi"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          torihikishi1_torokubango: {
            patterns: ['jtm-02'],
            warning: true
          },
          urinushi_gyosha_shogo: {
            patterns: ['jtm-02'],
            warning: true
          },
          urinushi_gyosha_daihyoshashimei: {
            patterns: ['jtm-02'],
            warning: true
          },
          jisha_daihyoshashimei: {
            warning: true
          },
          setsumei_torihikishi_jijyuujimusho_jyusho: {
            warning: () => {
              if(!$('#setsumei_torihikishi_jijyuujimusho_jyusho').html() || !$('#setsumei_torihikishi_jijyuujimusho_tenpo').html()) {
                $('div[name="setsumei_torihikishi_jijyuujimusho_jyusho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          setsumei_torihikishi_jijyuujimusho_tenpo: {
            warning: true
          },
          setsumei_torihikishi_torokubango: {
            patterns: ['jtm-01'],
            warning: true
          },
          setsumei_torihikishi_denwabango: {
            warning: true
          },
          torihikishi_bango: {
            patterns: ['jtm-02'],
            warning: true
          },
          torihikishi_shimei: {
            patterns: ['jtm-02'],
            warning: true
          },
          torihikishi_jijyuujimusho_jyusho: {
            patterns: ['jtm-02'],
            warning: true
          },
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[0]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[0]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[0]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_shozaichi"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho: {
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[0]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku1_eigyohoshokinkyotaku_meisho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked')  && !$('div[name="kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
              return false
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho: {
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_meisho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi: {
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_hoshokinkyokaijimusho_shozaichi"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho: {
            // patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && (!$('#jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho').html())) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_meisho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho: {
            // patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_torihikigyohoshokinkyotaku_jusho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho: {
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('#jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi: {
            warning: () => {
              const inputEl1 = $('input[name="jisha_kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') &&  !$('#jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi').html()) {
                $('div[name="jisha_kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_meisho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi: {
            patterns: ['jtm-02'],
            warning: () => {
              const inputEl1 = $('input[name="kyotakusho_setsumei"]')
              if($(inputEl1[1]).is(':checked') && !$('div[name="kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi"]').html()) {
                $('td[name="kyotakusho_setsumei_sentaku2_bensaigyomuhoshokin_shozaichi"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          setsumeishojyuryo_nengappi: {
            warning: () => {
              if($('td[name="setsumeishojyuryo_nengappi"]').html() === '年  月  日') {
                $('td[name="setsumeishojyuryo_nengappi"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jisha_menkyoshobango: {
            // patterns: ['jtm-02'],
            warning: true
          },
          jisha_menkyo_nengappi: {
            warning: () => {
              const momentTime = moment($('span[name="jisha_menkyo_nengappi_hidden"]').html(), 'YYYY-MM-DD')
              return !$('span[name="jisha_menkyo_nengappi_hidden"]').html() || (this.isNinetyDayAfterFiveYears(momentTime) && !this.isFiveYear(momentTime))
            }
          },
          menkyo_nengappi0: {
            warning: () => {
              const momentTime = moment($('span[name="menkyo_nengappi_hidden0"]').html(), 'YYYY-MM-DD')
              return this.isNinetyDayAfterFiveYears(momentTime) && !this.isFiveYear(momentTime)
            }
          },
          menkyo_nengappi1: {
            warning: () => {
              const momentTime = moment($('span[name="menkyo_nengappi_hidden1"]').html(), 'YYYY-MM-DD')
              return this.isNinetyDayAfterFiveYears(momentTime) && !this.isFiveYear(momentTime)
            }
          },
          jisha_shutaru_jimusho_shozaichi: {
            // patterns: ['jtm-02'],
            warning: true
          },
          jisha_shogo: {
            // patterns: ['jtm-02'],
            warning: true
          },
          setsumei_torihikishi_bango: {
            patterns: ['jtm-02'],
            warning: true
          },
          setsumei_torihikishi_shimei: {
            // patterns: ['jtm-02'],
            warning: true
          }
        },
        'jes':{
          tochi1: {
            patterns: ['jes-01', 'jes-02'],
            elements: [
              {
                shozai: {
                  warning: true
                },
                chibanmae: {
                  warning: true
                },
                chimoku1: {
                  warning: true
                },
                chiseki: {
                  warning: true
                },
                mochibun: {
                  warning: (idx) => {
                    const inputEl1 = $('span[name="mochibun1"]')
                    const inputEl2 = $('span[name="mochibun2"]')
                    return !$(inputEl1[idx]).html() || !$(inputEl2[idx]).html()
                  }
                }
              }
            ]
          },
          tochi2: {
            patterns: ['jes-04'],
            elements: [
              {
                shozai1: {
                  warning: true
                },
                chibanmae: {
                  warning: true
                },
                chimoku1: {
                  warning: true
                },
                chiseki: {
                  warning: true
                },
                mochibun: {
                  warning: (idx) => {
                    const inputEl1 = $('span[name="mochibun1"]')
                    const inputEl2 = $('span[name="mochibun2"]')
                    return !$(inputEl1[idx]).html() || !$(inputEl2[idx]).html()
                  }
                }
              }
            ]
          },
          shikikentochi: {
            patterns: ['jes-03'],
            elements: [
              {
                shozai: {
                  warning: (idx) => {
                    const inputEl1 = $('span[name="shozai"]')
                    const inputEl2 = $('span[name="chibanmae"]')
                    return !$(inputEl1[idx]).html() || !$(inputEl2[idx]).html()
                  }
                },
                chimoku1: {
                  warning: true
                },
                chiseki: {
                  warning: true
                },
                wariai: {
                  warning: (idx) => {
                    const inputEl1 = $('span[name="wariai1"]')
                    const inputEl2 = $('span[name="wariai2"]')
                    return !$(inputEl1[idx]).html() || !$(inputEl2[idx]).html()
                  }
                }
              }
            ]
          },
          tochi1_gokeimenseki: {
            patterns: ['jes-01', 'jes-02'],
            warning: () => {
              return !$('td[name="tochi1_gokeimenseki"]').html()
            }
          },
          shikikentochi_tochi2_gokeimenseki: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              return !$('td[name="shikikentochi_tochi2_gokeimenseki"]').html()
            }
          },
          tatemono_shozai: {
            patterns: ['jes-02'],
            warning: () => {
              return !$('span[name="tatemono_shozai"]').html()
            }
          },
          tochibaibaitaishomenseki_sentaku: {
            patterns: ['jes-01', 'jes-02'],
            warning: () => {
              const inputEl = $('input[name="tochibaibaitaishomenseki_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl[2]).is(':checked')
            }
          },
          tochibaibaitaishomenseki_sentaku3_nyuryoku: {
            patterns: ['jes-01', 'jes-02'],
            warning: () => {
              const inputEl = $('input[name="tochibaibaitaishomenseki_sentaku"]')
              return $(inputEl[2]).is(':checked') && !$('td[name="tochibaibaitaishomenseki_sentaku3_nyuryoku"]').html()
            }
          },
          sokuryozumen_sentaku: {
            patterns: ['jes-01', 'jes-02'],
            warning: () => {
              const inputEl = $('input[name="sokuryozumen_sentaku"]')
              return !$($('input[name="sokuryozumen_kainushi_kofu"]')[2]).is(':checked') && (!$(inputEl[0]).is(':checked') || !$(inputEl[1]).is(':checked'))
            }
          },
          kenrishurui_shoyuken: {
            patterns: ['jes-02', 'jes-04'],
            warning: () => {
              const inputEl = $('input[name="kenrishurui_shoyuken"]')
              const inputEl2 = $('input[name="kenrishurui_shakuchiken"]')
              return !$(inputEl[0]).is(':checked')  && !$(inputEl2[0]).is(':checked')
            }
          },
          kenrishurui_shakuchiken: {
            patterns: ['jes-02', 'jes-04'],
            warning: () => {
              const inputEl = $('input[name="kenrishurui_shoyuken"]')
              const inputEl2 = $('input[name="kenrishurui_shakuchiken"]')
              return !$(inputEl[0]).is(':checked')  && !$(inputEl2[0]).is(':checked')
            }
          },
          kenrishurui_chijoken: {
            patterns: ['jes-02', 'jes-04'],
            warning: () => {
              const inputEl1 = $('input[name="kenrishurui_shakuchiken"]')
              const inputEl2 = $('input[name="kenrishurui_chijoken"]')
              const inputEl3 = $('input[name="kenrishurui_chinshaku"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          kenrishurui_chinshaku: {
            patterns: ['jes-02', 'jes-04'],
            warning: () => {
              const inputEl1 = $('input[name="kenrishurui_shakuchiken"]')
              const inputEl2 = $('input[name="kenrishurui_chijoken"]')
              const inputEl3 = $('input[name="kenrishurui_chinshaku"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          shakuchitaisho_menseki: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl = $('td[name="shakuchitaisho_menseki"]')
              const inputEl1 = $('input[name="kenrishurui_shakuchiken"]')
              const inputEl2 = $('input[name="kenrishurui_chijoken"]')
              const inputEl3 = $('input[name="kenrishurui_chinshaku"]')
              return !$(inputEl[0]).html() && ($(inputEl1[0]).is(':checked') || $(inputEl2[0]).is(':checked') || $(inputEl3[0]).is(':checked'))
            }
          },
          tatemonomeisho: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          tatemonomeisho_kai: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              const inputEl1 = $('span[name="tatemonomeisho_kai"]')
              const inputEl2 = $('span[name="tatemonomeisho_goshitsu"]')
              return !$(inputEl1[0]).html() || !$(inputEl2[0]).html()
            }
          },
          // tatemonomeisho_goshitsu: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: true
          // },
          jukyo_hyoji: {
            patterns: ['jes-03', 'jes-04'],
            warning: true
          },
          ittiotatemono_shozai: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              const inputEl1 = $('span[name="ittiotatemono_shozai"]')
              const inputEl2 = $('span[name="ittiotatemono_chibanmae"]')
              return !$(inputEl1[0]).html() || !$(inputEl2[0]).html()
            }

          },
          ittiotatemono_chibanmae: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          ittiotatemono_kozo_zou1: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              const inputEl1 = $('span[name="ittiotatemono_kozo_zou2"]')
              const inputEl2 = $('span[name="ittiotatemono_kozo_kaidate1"]')
              const inputEl3 = $('span[name="ittiotatemono_kozo_kaidate2"]')
              return !$(inputEl1[0]).html() || !$(inputEl2[0]).html() || !$(inputEl3[0]).html()
            }
          },
          // ittiotatemono_kozo_zou2: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: () => {
          //     return true
          //   }

          // },
          // ittiotatemono_kozo_fuki1: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: true

          // },
          // ittiotatemono_kozo_fuki2: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: true

          // },
          // ittiotatemono_kozo_kaidate1: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: true

          // },
          // ittiotatemono_kozo_kaidate2: {
          //   patterns: ['jes-03', 'jes-04'],
          //   warning: true

          // },
          ittiotatemono_nobetokomenseki: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_yaokubango: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_meisho: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_shurui1: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_shurui2: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_kozo: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              // const inputEl1 = $('span[name="senyububun_kozo1"]')
              // const inputEl2 = $('span[name="senyububun_kozo2"]')
              const inputEl3 = $('span[name="senyububun_kozo3"]')
              return !$(inputEl3[0]).html()
            }
          },
          senyububun_yukamenseki_tokibogaibubun: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_yukamenseki: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_yukamenseki_hekishin: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_kenchikunengo: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_kenchikunen: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_kenchikugatsu: {
            patterns: ['jes-03', 'jes-04'],
            warning: true

          },
          senyububun_kenchikujiki_nyuryoku: {
            patterns: ['jes-03', 'jes-04'],
            warning: true
          },
          tatemono_jushohyoji: {
            patterns: ['jes-02'],
            warning: true

          },
          tatemono_yaokubango: {
            patterns: ['jes-02'],
            warning: true

          },
          tatemono_shurui1: {
            patterns: ['jes-02'],
            warning: true
          },
          tatemono_shurui2: {
            patterns: ['jes-02'],
            warning: true
          },
          tatemono_kozo_zou1: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl1 = $('div[name="tatemono_kozo_zou1"]')
              return !$(inputEl1[0]).html()
            }
          },
          tatemono_menseki_kubun1: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl = $('input[name="tatemono_menseki_kubun1"]')
              const inputEl2 = $('input[name="tatemono_menseki_kubun2"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          tatemono_menseki_kubun2: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl = $('input[name="tatemono_menseki_kubun1"]')
              const inputEl2 = $('input[name="tatemono_menseki_kubun2"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          tatemono_yukamenseki_1kai: {
            patterns: ['jes-02'],
            warning: true

          },
          tatemono_yukamenseki_gokei: {
            patterns: ['jes-02'],
            warning: true

          },
          tatemono_kenchikunengo: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl = $('span[name="tatemono_kenchikunengo"]')
              const inputEl2 = $('span[name="tatemono_kenchikunen"]')
              return !$(inputEl[0]).html() || !$(inputEl2[0]).html()
            }
          },
          tatemono_kenchikugatsu: {
            patterns: ['jes-02'],
            warning: true
          },
          tatemono_kenchikujikiu: {
            patterns: ['jes-02'],
            warning: () => {
              return ($('td[name="tatemono_kenchikujikiu"]').html() === '年  月')
            }
          },
          senyububun_kenchikujiki: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              return $('td[name="senyububun_kenchikujiki"]').html() === '年  月'
            }
          },
          tatemono_zokaichikujikan: {
            patterns: ['jes-02'],
            warning: () => {
              const inputEl = $('input[name="tatemono_zokaichikujiki"]')
              return ($(inputEl[0]).is(':checked') || $(inputEl[1]).is(':checked')) && ($('td[name="tatemono_zokaichikujikan"]').html() === '年  月')
            }
          },
          kanrikiyaku_kiyakushikichi_sadame: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              const inputEl = $('input[name="kanrikiyaku_kiyakushikichi_sadame"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          senyububun_kenchikunen_shorai: {
            patterns: ['jes-03', 'jes-04'],
            warning: () => {
              const inputE1 = $('td[name="senyububun_kenchikunengo"]')
              const inputE2 = $('td[name="senyububun_kenchikunen"]')
              const inputE3 = $('td[name="senyububun_kenchikugatsu"]')
              if(inputE1.html() !== '' && inputE2.html() !== '' && inputE3.html() !== '') {
                const year = (inputE1.html() === '平成' ? 1988 : 2018)  + (+inputE2.html())
                const monthCount = (year * 12) + (+inputE3.html())
                const currentMonthCount =  (moment().year() * 12) + moment().month() + 1
                if(monthCount >=  currentMonthCount) {
                  $(inputE1).css({'background-color': 'rgb(255 224 146 / 60%)'})
                  $(inputE2).css({'background-color': 'rgb(255 224 146 / 60%)'})
                  $(inputE3).css({'background-color': 'rgb(255 224 146 / 60%)'})
                  return true
                }
              }
            }
          }
        },
        'jse':{ // OK
          urinushi_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="urinushi_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          urinushi_jusho: {
            warning: true
          },
          urinushi_shimei: {
            warning: true
          },
          daisanshasenyu_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="daisanshasenyu_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          daisanshasenyu_jusho: {
            warning: () => {
              const checkboxEl = $('input[name="daisanshasenyu_umusentaku"]')
              return $(checkboxEl[0]).is(':checked') && !$('td[name="daisanshasenyu_jusho"]').html()
            }
          },
          daisanshasenyu_shimei: {
            warning: () => {
              const checkboxEl = $('input[name="daisanshasenyu_umusentaku"]')
              return $(checkboxEl[0]).is(':checked') && !$('td[name="daisanshasenyu_shimei"]').html()
            }
          }
        },
        'jrb':{
          // M007-04 - OK
          tokijiko_taisho1_shomeinengappi: {
            warning: () => {
              if ($('.tokijiko_taisho1_shomeinengappi').find('span[name="tokijiko_taisho1_shomeinengappi"]').html() === '年  月  日') {
                $('.tokijiko_taisho1_shomeinengappi').css({'background-color': 'rgb(255 224 146 / 60%)'})
              } else {
                $('.tokijiko_taisho1_shomeinengappi').css({'background-color': 'transparent'})
              }
              return false
            }
          },
          tokijiko_taisho2_shomeinengappi: {
            warning: () => {
              if ($('.tokijiko_taisho2_shomeinengappi').find('span[name="tokijiko_taisho2_shomeinengappi"]').html() === '年  月  日') {
                $('.tokijiko_taisho2_shomeinengappi').css({'background-color': 'rgb(255 224 146 / 60%)'})
              } else {
                $('.tokijiko_taisho2_shomeinengappi').css({'background-color': 'transparent'})
              }
              return false
            }
          },
          tokijiko_taisho1_koku_jusho: {
            warning: true
          },
          tokijiko_taisho1_koku_shimei: {
            warning: true
          },
          tokijiko_taisho2_koku_jusho: {
            warning: true
          },
          tokijiko_taisho2_koku_shimei: {
            warning: true
          },
          tokijiko_taisho1_koku_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tokijiko_taisho1_koku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tokijiko_taisho2_koku_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tokijiko_taisho2_koku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tokijiko_taisho1_otsuku_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tokijiko_taisho1_otsuku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tokijiko_taisho2_otsuku_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tokijiko_taisho2_otsuku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tokijiko_taisho1_otsuku_tokinaiyo: {
            warning: () => {
              const inputEl =  ($('div[name="tokijiko_taisho1_otsuku_tokinaiyo"]').html())
              // eslint-disable-next-line eqeqeq
              if(inputEl == '<div>以下余白</div>' || inputEl == '') {
                return true
              } else {
                return false
              }
            }
          },
          tokijiko_taisho1_koku_tokinaiyo: {
            warning: () => {
              const inputEl =  ($('div[name="tokijiko_taisho1_koku_tokinaiyo"]').html())
              // eslint-disable-next-line eqeqeq
              if(inputEl == '<div>以下余白</div>' || inputEl == '') {
                return true
              } else {
                return false
              }
            }
          },
          tokijiko_taisho2_koku_tokinaiyo: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl =  ($('div[name="tokijiko_taisho2_koku_tokinaiyo"]').html())
              // eslint-disable-next-line eqeqeq
              if(inputEl == '<div>以下余白</div>' || inputEl == '') {
                return true
              } else {
                return false
              }
            }
          },
          tokijiko_taisho2_otsuku_tokinaiyo: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl =  ($('div[name="tokijiko_taisho2_otsuku_tokinaiyo"]').html())
              // eslint-disable-next-line eqeqeq
              if(inputEl == '<div>以下余白</div>' || inputEl == '') {
                return true
              } else {
                return false
              }
            }
          },

          // M007-05 OK
          kuiki_kubun1: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun1"]')
              const inputEl2 = $('input[name="kuiki_kubun2"]')
              return !inputEl1.is(':checked') && !inputEl2.is(':checked')
            }
          },
          kuiki_kubun2: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun1"]')
              const inputEl2 = $('input[name="kuiki_kubun2"]')
              return !inputEl1.is(':checked') && !inputEl2.is(':checked')
            }
          },
          kuiki_sabu_kubun1: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun1"]')
              const inputEl2 = $('input[name="kuiki_sabu_kubun1"]')
              const inputEl3 = $('input[name="kuiki_sabu_kubun2"]')
              const inputEl4 = $('input[name="kuiki_sabu_kubun3"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          kuiki_sabu_kubun2: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun1"]')
              const inputEl2 = $('input[name="kuiki_sabu_kubun1"]')
              const inputEl3 = $('input[name="kuiki_sabu_kubun2"]')
              const inputEl4 = $('input[name="kuiki_sabu_kubun3"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          kuiki_sabu_kubun3: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun1"]')
              const inputEl2 = $('input[name="kuiki_sabu_kubun1"]')
              const inputEl3 = $('input[name="kuiki_sabu_kubun2"]')
              const inputEl4 = $('input[name="kuiki_sabu_kubun3"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          jyuntoshikeikakuiki_shitei: {
            warning: () => {
              const inputEl1 = $('input[name="kuiki_kubun2"]')
              const inputEl2 = $('input[name="jyuntoshikeikakuiki_shitei"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          toshikeikaku_shisetsu_umusentaku: {
            warning: () => {
              const checkBoxEl = $('input[name="toshikeikaku_shisetsu_umusentaku"]')
              return !$(checkBoxEl[0]).is('checked') && !$(checkBoxEl[1]).is('checked')
            }
          },
          // toshikeikaku_shisetsu_doro_shinpodankai: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="toshikeikaku_shisetsu_umusentaku"]')
          //     const inputEl2 = $('input[name="toshikeikaku_shisetsu_doro_shinpodankai"]')
          //     return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl2[1]).is(':checked')
          //   }
          // },
          toshikeikaku_shisetsu_doro: {
            warning: () => {
              const inputEl1 = $('input[name="toshikeikaku_shisetsu_umusentaku"]')
              const inputEl2 = $('input[name="toshikeikaku_shisetsu_doro"]')
              const inputEl3 = $('input[name="toshikeikaku_shisetsu_sonohoka"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          toshikeikaku_shisetsu_sonohoka: {
            warning: () => {
              const inputEl1 = $('input[name="toshikeikaku_shisetsu_umusentaku"]')
              const inputEl2 = $('input[name="toshikeikaku_shisetsu_doro"]')
              const inputEl3 = $('input[name="toshikeikaku_shisetsu_sonohoka"]')
              return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          toshikeikaku_shisetsu_doro_meisho: {
            warning: () => {
              const inputEl1 = $('input[name="toshikeikaku_shisetsu_doro"]')
              return inputEl1.is(':checked') && !$('td[name="toshikeikaku_shisetsu_doro_meisho"]').html()
            }
          },
          settobakku_menseki_gensho_umusentaku: {
            warning: () => {
              const inputEl1 = $('input[name="settobakku_menseki_gensho_umusentaku"]')
              return (!$(inputEl1[0]).is(':checked') && !$(inputEl1[1]).is(':checked'))
            }
          },
          // shigaichi_kaihatsu__umusentaku: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="shigaichi_kaihatsu__umusentaku"]')
          //     return (!$(inputEl1[0]).is(':checked'))
          //   }
          // },
          // shigaichi_kaihatsu__nyuryoku: {
          //   warning: () => {
          //     return !$('td[name="shigaichi_kaihatsu__nyuryoku"]').html()
          //   }
          // },
          yotochiiki1: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki2: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki3: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki4: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki5: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki6: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki7: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki8: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki9: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki10: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki11: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki12: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki13: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl9[0]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl12[0]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl14[0]).is(':checked')
            }
          },
          yotochiiki14: {
            warning: () => {
              const inputEl1 = $('input[name="yotochiiki1"]')
              const inputEl2 = $('input[name="yotochiiki2"]')
              const inputEl3 = $('input[name="yotochiiki3"]')
              const inputEl4 = $('input[name="yotochiiki4"]')
              const inputEl5 = $('input[name="yotochiiki5"]')
              const inputEl6 = $('input[name="yotochiiki6"]')
              const inputEl7 = $('input[name="yotochiiki7"]')
              const inputEl8 = $('input[name="yotochiiki8"]')
              const inputEl9 = $('input[name="yotochiiki9"]')
              const inputEl10 = $('input[name="yotochiiki10"]')
              const inputEl11 = $('input[name="yotochiiki11"]')
              const inputEl12 = $('input[name="yotochiiki12"]')
              const inputEl13 = $('input[name="yotochiiki13"]')
              const inputEl14 = $('input[name="yotochiiki14"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl1[1]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl2[1]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl3[1]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl4[1]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl5[1]).is(':checked') && !$(inputEl6[0]).is(':checked') && !$(inputEl6[1]).is(':checked')
              && !$(inputEl7[0]).is(':checked') && !$(inputEl7[1]).is(':checked') && !$(inputEl8[0]).is(':checked') && !$(inputEl8[1]).is(':checked') && !$(inputEl9[0]).is(':checked') && !$(inputEl9[1]).is(':checked')
              && !$(inputEl10[0]).is(':checked') && !$(inputEl10[1]).is(':checked') && !$(inputEl11[0]).is(':checked') && !$(inputEl11[1]).is(':checked') && !$(inputEl12[0]).is(':checked') && !$(inputEl12[1]).is(':checked')
              && !$(inputEl13[0]).is(':checked') && !$(inputEl13[1]).is(':checked') && !$(inputEl14[0]).is(':checked') && !$(inputEl14[1]).is(':checked')
            }
          },
          kenpeiritsu: {
            warning: () => {
              if(!$('div[name="kenpeiritsu"]').html()) {
                $('div[name="kenpeiritsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          yosekiritsu: {
            warning: () => {
              if(!$('div[name="yosekiritsu"]').html()) {
                $('div[name="yosekiritsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          dorofukuinyaku: {
            warning: true
          },
          doroshurui1: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui2: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui3: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui4: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui5: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui6: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          doroshurui7: {
            warning: () => {
              const inputEl1 = $('input[name="doroshurui1"]')
              const inputEl2 = $('input[name="doroshurui2"]')
              const inputEl3 = $('input[name="doroshurui3"]')
              const inputEl4 = $('input[name="doroshurui4"]')
              const inputEl5 = $('input[name="doroshurui5"]')
              const inputEl6 = $('input[name="doroshurui6"]')
              const inputEl7 = $('input[name="doroshurui7"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
              && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
              && !$(inputEl7[0]).is(':checked')
            }
          },
          // jorei_seigen_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="jorei_seigen_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          shido_henko_haishi: {
            warning: () => {
              const inputEl = $('input[name="shido_henko_haishi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hekimensen_seigen: {
            warning: () => {
              const inputEl = $('input[name="hekimensen_seigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shikichimennseki_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="shikichimennseki_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tatemono_takasa_seigen_zettaitakasa_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tatemono_takasa_seigen_zettaitakasa_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tatemono_takasa_seigen_zettaitakasa_sabusentaku: {
            warning: () => {
              const inputEl1 = $('input[name="tatemono_takasa_seigen_zettaitakasa_umusentaku"]')
              const inputEl2 = $('input[name="tatemono_takasa_seigen_zettaitakasa_sabusentaku"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl1[1]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl2[1]).is(':checked')
            }
          },
          doroshasen_seigen: {
            warning: () => {
              const inputEl = $('input[name="doroshasen_seigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          rinchishasen_seigen: {
            warning: () => {
              const inputEl = $('input[name="rinchishasen_seigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kitagawa_shasen_seigen: {
            warning: () => {
              const inputEl = $('input[name="kitagawa_shasen_seigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hikagekoso_seigen_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="hikagekoso_seigen_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hikagekoso_seigen_shumei: {
            warning: () => {
              const inputEl = $('input[name="hikagekoso_seigen_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="hikagekoso_seigen_shumei"]').html()
            }
          },
          kenchikukyotei_biko: {
            warning: () => {
              const inputEl = $('input[name="kenchikukyotei_biko"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shikichimennseki_saiteigendo: {
            warning: () => {
              const inputEl = $('input[name="shikichimennseki_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shikichimennseki_saiteigendo"]').html()
            }
          },
          gaihekikotai: {
            warning: () => {
              const inputEl = $('input[name="gaihekikotai"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tochikukakuseirihoseigen_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="tochikukakuseirihoseigen_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          setsudo_nagasa_tanihyoji1: {
            warning: () => {
              if((!$('div[name="setsudo_nagasa_tanihyoji1"]').html() && $('td[name="zenmendoro1_setsudo_nagasa"]').html()) || (this.arrText.includes($('div[name="setsudo_nagasa_tanihyoji1"]').html()) && !this.arrText.includes($('td[name="zenmendoro1_setsudo_nagasa"]').html()))) {
                $('td[name="setsudo_nagasa_tanihyoji1"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          setsudo_nagasa_tanihyoji2: {
            warning: () => {
              if((!$('div[name="setsudo_nagasa_tanihyoji2"]').html() && $('td[name="zenmendoro2_setsudo_nagasa"]').html()) || (this.arrText.includes($('div[name="setsudo_nagasa_tanihyoji2"]').html()) && !this.arrText.includes($('td[name="zenmendoro2_setsudo_nagasa"]').html()))) {
                $('td[name="setsudo_nagasa_tanihyoji2"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          setsudo_nagasa_tanihyoji3: {
            warning: () => {
              if((!$('div[name="setsudo_nagasa_tanihyoji3"]').html() && $('td[name="zenmendoro3_setsudo_nagasa"]').html()) || (this.arrText.includes($('div[name="setsudo_nagasa_tanihyoji3"]').html()) && !this.arrText.includes($('td[name="zenmendoro3_setsudo_nagasa"]').html()))) {
                $('td[name="setsudo_nagasa_tanihyoji3"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          setsudo_nagasa_tanihyoji4: {
            warning: () => {
              if((!$('div[name="setsudo_nagasa_tanihyoji4"]').html() && $('td[name="zenmendoro4_setsudo_nagasa"]').html()) || (this.arrText.includes($('div[name="setsudo_nagasa_tanihyoji4"]').html()) && !this.arrText.includes($('td[name="zenmendoro4_setsudo_nagasa"]').html()))) {
                $('td[name="setsudo_nagasa_tanihyoji4"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          // M007-06 - OK
          futanmenseki_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="futanmenseki_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          futanmenseki: {
            warning: () => {
              const inputEl = $('input[name="futanmenseki_umusentaku"]')
              if($(inputEl[0]).is(':checked') && !$('#futanmenseki').html()) {
                $('div[name="futanmenseki"]').parents('td').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shidojiko_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="shidojiko_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shidojiko_shoyusha_jusho: {
            warning: () => {
              const inputEl = $('input[name="shidojiko_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shidojiko_shoyusha_jusho"]').html()
            }
          },
          shidojiko_shoyusha_shimei: {
            warning: () => {
              const inputEl = $('input[name="shidojiko_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shidojiko_shoyusha_shimei"]').html()
            }
          },
          // M007-07 - OK
          inyomizu1_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu1_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu1_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu1_kanonashisetsu_shieisuido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu1_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu1_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu1_kanonashisetsu_ido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu1_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu1_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu1_jokyo_zenmendorohaikan_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_jokyo_zenmendorohaikan_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          inyomizu1_jokyo_zenmendorohaikan_kokei: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_jokyo_zenmendorohaikan_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="inyomizu1_jokyo_zenmendorohaikan_kokei"]').html()
            }
          },
          gasu1_jokyo_zenmendorohaikan_kokei: {
            warning: () => {
              const inputEl = $('input[name="gasu1_jokyo_zenmendorohaikan_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="gasu1_jokyo_zenmendorohaikan_kokei"]').html()
            }
          },
          inyomizu1_jokyo_shikichinaihikikomikan_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_jokyo_shikichinaihikikomikan_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          inyomizu1_jokyo_shikichinaihikikomikan_kokei: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_jokyo_shikichinaihikikomikan_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="inyomizu1_jokyo_shikichinaihikikomikan_kokei"]').html()
            }
          },
          inyomizu1_jokyo_shisetsukan_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_jokyo_shisetsukan_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          inyomizu1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          inyomizu1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="inyomizu1_seibiyotei_nengetsu"]').html() === '年  月頃') {
                $('td[name="inyomizu1_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          inyomizu1_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="inyomizu1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && ($('td[name="inyomizu1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`)
            }
          },
          amamizu1_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="amamizu1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && $('td[name="amamizu1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`
            }
          },
          denki1_kanonashisetsu_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="denki1_kanonashisetsu_umusentaku"]')
              return !$(inputEl[0]).is(':checked')
            }
          },
          denki1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="denki1_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          gasu1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="gasu1_seibiyotei_futankin_umusentaku"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          gasu1_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="gasu1_seibiyotei_futankin_umusentaku"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return $(inputEl[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && $('td[name="gasu1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`
            }
          },
          osui1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="osui1_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          amamizu1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="amamizu1_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          denki1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="denki1_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="denki1_seibiyotei_nengetsu"]').html() === '年  月頃') {
                $('td[name="denki1_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          denki1_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="denki1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && $('td[name="denki1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`
            }
          },
          zatsuhaisui1_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="zatsuhaisui1_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          zatsuhaisui1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="zatsuhaisui1_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="zatsuhaisui1_seibiyotei_nengetsu"]').html() === '年  月頃') {
                $('td[name="zatsuhaisui1_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          zatsuhaisui1_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="zatsuhaisui1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && ($('td[name="zatsuhaisui1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`)
            }
          },
          denki2_kanonashisetsu_ikkatsujuden_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="denki2_kanonashisetsu_ikkatsujuden_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          denki2_kanonashisetsu_ikkatsujuden_sabisugaisha: {
            warning: () => {
              const inputEl = $('input[name="denki2_kanonashisetsu_ikkatsujuden_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="denki2_kanonashisetsu_ikkatsujuden_sabisugaisha"]').html()
            }
          },
          denki2_kanonashisetsu_ikkatsujuden_keiyakukikan: {
            warning: () => {
              const inputEl = $('input[name="denki2_kanonashisetsu_ikkatsujuden_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="denki2_kanonashisetsu_ikkatsujuden_keiyakukikan"]').html() === '年  月  日迄') {
                $('td[name="denki2_kanonashisetsu_ikkatsujuden_keiyakukikan"]').css({'background-color': 'rgb(255 224 146 / 60%)'})

              }
            }
          },
          gasu1_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="gasu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu1_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu1_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          gasu1_kanonashisetsu_kobetsupuropan: {
            warning: () => {
              const inputEl1 = $('input[name="gasu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu1_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu1_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          gasu1_kanonashisetsu_shuchupuropan: {
            warning: () => {
              const inputEl1 = $('input[name="gasu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu1_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu1_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          // osui1_kanonashisetsu_koeisuido: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_koeisuido"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_shuchujokaso"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_kumitorishiki"]')
          //     return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          // osui1_kanonashisetsu_kobetsujokaso: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_koeisuido"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_shuchujokaso"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_kumitorishiki"]')
          //     return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          // osui1_kanonashisetsu_shuchujokaso: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_koeisuido"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_shuchujokaso"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_kumitorishiki"]')
          //     return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          // osui1_kanonashisetsu_kumitorishiki: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_koeisuido"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_shuchujokaso"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_kumitorishiki"]')
          //     return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          zatsuhaisui1_kanonashisetsu_shintoshiki: {
            warning: () => {
              const inputEl1 = $('input[name="zatsuhaisui1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="zatsuhaisui1_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="zatsuhaisui1_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="zatsuhaisui1_kanonashisetsu_sokko"]')
              const inputEl5 = $('input[name="zatsuhaisui1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          zatsuhaisui1_kanonashisetsu_sokko: {
            warning: () => {
              const inputEl1 = $('input[name="zatsuhaisui1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="zatsuhaisui1_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="zatsuhaisui1_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="zatsuhaisui1_kanonashisetsu_sokko"]')
              const inputEl5 = $('input[name="zatsuhaisui1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          zatsuhaisui1_kanonashisetsu_shuchujokaso: {
            warning: () => {
              const inputEl1 = $('input[name="zatsuhaisui1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="zatsuhaisui1_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="zatsuhaisui1_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="zatsuhaisui1_kanonashisetsu_sokko"]')
              const inputEl5 = $('input[name="zatsuhaisui1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          zatsuhaisui1_kanonashisetsu_kobetsujokaso: {
            warning: () => {
              const inputEl1 = $('input[name="zatsuhaisui1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="zatsuhaisui1_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="zatsuhaisui1_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="zatsuhaisui1_kanonashisetsu_sokko"]')
              const inputEl5 = $('input[name="zatsuhaisui1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          zatsuhaisui1_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="zatsuhaisui1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="zatsuhaisui1_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="zatsuhaisui1_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="zatsuhaisui1_kanonashisetsu_sokko"]')
              const inputEl5 = $('input[name="zatsuhaisui1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          // osui1_kanonashisetsu_horyu_maisetsu: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_horyu_maisetsu"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_horyu_sokko"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_horyu_shintoshiki"]')
          //     return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          // osui1_kanonashisetsu_horyu_sokko: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_horyu_maisetsu"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_horyu_sokko"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_horyu_shintoshiki"]')
          //     return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          // osui1_kanonashisetsu_horyu_shintoshiki: {
          //   warning: () => {
          //     const inputEl1 = $('input[name="osui1_kanonashisetsu_kobetsujokaso"]')
          //     const inputEl2 = $('input[name="osui1_kanonashisetsu_horyu_maisetsu"]')
          //     const inputEl3 = $('input[name="osui1_kanonashisetsu_horyu_sokko"]')
          //     const inputEl4 = $('input[name="osui1_kanonashisetsu_horyu_shintoshiki"]')
          //     return $(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
          //   }
          // },
          amamizu1_kanonashisetsu_shintoshiki: {
            warning: () => {
              const inputEl1 = $('input[name="amamizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="amamizu1_kanonashisetsu_sokko"]')
              const inputEl3 = $('input[name="amamizu1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          amamizu1_kanonashisetsu_sokko: {
            warning: () => {
              const inputEl1 = $('input[name="amamizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="amamizu1_kanonashisetsu_sokko"]')
              const inputEl3 = $('input[name="amamizu1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          amamizu1_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="amamizu1_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="amamizu1_kanonashisetsu_sokko"]')
              const inputEl3 = $('input[name="amamizu1_kanonashisetsu_shintoshiki"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu2_kanonashisetsu_ido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu2_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu2_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu2_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu2_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu2_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          inyomizu2_kanonashisetsu_shieisuido: {
            warning: () => {
              const inputEl1 = $('input[name="inyomizu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="inyomizu2_kanonashisetsu_shieisuido"]')
              const inputEl3 = $('input[name="inyomizu2_kanonashisetsu_ido"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          gasu2_kanonashisetsu_nashi: {
            warning: () => {
              const inputEl1 = $('input[name="gasu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu2_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu2_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu2_kanonashisetsu_nashi"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          gasu2_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="gasu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu2_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu2_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu2_kanonashisetsu_nashi"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          gasu2_kanonashisetsu_kobetsupuropan: {
            warning: () => {
              const inputEl1 = $('input[name="gasu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu2_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu2_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu2_kanonashisetsu_nashi"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          gasu2_kanonashisetsu_shuchupuropan: {
            warning: () => {
              const inputEl1 = $('input[name="gasu2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="gasu2_kanonashisetsu_kobetsupuropan"]')
              const inputEl3 = $('input[name="gasu2_kanonashisetsu_shuchupuropan"]')
              const inputEl4 = $('input[name="gasu2_kanonashisetsu_nashi"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          haisui2_kanonashisetsu_shuchujokaso: {
            warning: () => {
              const inputEl1 = $('input[name="haisui2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="haisui2_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="haisui2_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="haisui2_kanonashisetsu4"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          haisui2_kanonashisetsu_koeisuido: {
            warning: () => {
              const inputEl1 = $('input[name="haisui2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="haisui2_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="haisui2_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="haisui2_kanonashisetsu4"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          haisui2_kanonashisetsu_kobetsujokaso: {
            warning: () => {
              const inputEl1 = $('input[name="haisui2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="haisui2_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="haisui2_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="haisui2_kanonashisetsu4"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          haisui2_kanonashisetsu4: {
            warning: () => {
              const inputEl1 = $('input[name="haisui2_kanonashisetsu_koeisuido"]')
              const inputEl2 = $('input[name="haisui2_kanonashisetsu_kobetsujokaso"]')
              const inputEl3 = $('input[name="haisui2_kanonashisetsu_shuchujokaso"]')
              const inputEl4 = $('input[name="haisui2_kanonashisetsu4"]')
              return !$(inputEl1[0]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked') && !$(inputEl4[0]).is(':checked')
            }
          },
          gasu1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="gasu1_seibiyotei_futankin_umusentaku"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              if($(inputEl[0]).is(':checked') && ($('td[name="gasu1_seibiyotei_nengetsu"]').html() === '年  月頃') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')) {
                $('td[name="gasu1_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          osui1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="osui1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && $('td[name="osui1_seibiyotei_nengetsu"]').html() === '年  月頃'
            }
          },
          osui1_seibiyotei_futankin: { 
            warning: () => {
              const inputEl = $('input[name="osui1_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && ($('td[name="osui1_seibiyotei_futankin"]').html() === `${this.arrText[1]}円`)
            }
          },
          amamizu1_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="amamizu1_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="amamizu1_seibiyotei_nengetsu"]').html() === '年  月頃') {
                $('td[name="amamizu1_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          inyomizu2_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="inyomizu2_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && ($('td[name="inyomizu2_seibiyotei_nengetsu"]').html() === '年  月頃')) {
                $('td[name="inyomizu2_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          gasu2_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="gasu2_seibiyotei_futankin_umusentaku"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              if($(inputEl[0]).is(':checked') && $('td[name="gasu2_seibiyotei_nengetsu"]').html() === '年  月頃' && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')) {
                $('td[name="gasu2_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          haisui2_seibiyotei_nengetsu: {
            warning: () => {
              const inputEl = $('input[name="haisui2_seibiyotei_futankin_umusentaku"]')
              if($(inputEl[0]).is(':checked') && $('td[name="haisui2_seibiyotei_nengetsu"]').html() === '年  月頃') {
                $('td[name="haisui2_seibiyotei_nengetsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          gasu2_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="gasu2_seibiyotei_futankin_umusentaku"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="gasu2_seibiyotei_futankin"]').html() && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          haisui2_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="haisui2_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="haisui2_seibiyotei_futankin"]').html()
            }
          },
          gasu1_jokyo_zenmendorohaikan_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="gasu1_jokyo_zenmendorohaikan_umusentaku"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          haisui2_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="haisui2_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          gasu2_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="gasu2_seibiyotei_futankin_umusentaku"]')
              const inputEl5 = $('input[name="gasu2_orudenka"]')
              const inputEl6 = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl5[0]).is(':checked') && !$(inputEl6[0]).is(':checked')
            }
          },
          inyomizu2_seibiyotei_futankin: {
            warning: () => {
              const inputEl = $('input[name="inyomizu2_seibiyotei_futankin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="inyomizu2_seibiyotei_futankin"]').html()
            }
          },
          inyomizu2_seibiyotei_futankin_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="inyomizu2_seibiyotei_futankin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          gasu1_jokyo_shikichinaihikikomikan_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="gasu1_jokyo_shikichinaihikikomikan_umusentaku"]')
              const inputEl4 = $('input[name="gasu1_orudenka"]')
              const inputEl5 = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl4[0]).is(':checked') && !$(inputEl5[0]).is(':checked')
            }
          },
          gasu1_orudenka: {
            warning: () => {
              const inputEl = $('input[name="gasu1_orudenka"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          // osui1_jokyo_zenmendorohaikan_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="osui1_jokyo_zenmendorohaikan_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          // osui1_jokyo_shisetsukan_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="osui1_jokyo_shisetsukan_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          // osui1_jokyo_shikichinaihikikomikan_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="osui1_jokyo_shikichinaihikikomikan_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          // zatsuhaisui1_jokyo_zenmendorohaikan_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="zatsuhaisui1_jokyo_zenmendorohaikan_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          // zatsuhaisui1_jokyo_shisetsukan_umusentaku: {
          //   warning: () => {
          //     const inputEl = $('input[name="zatsuhaisui1_jokyo_shisetsukan_umusentaku"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          gasu2_orudenka: {
            warning: () => {
              const inputEl = $('input[name="gasu2_orudenka"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          gasu1_kochi_haikansetsubi_nashi: {
            warning: () => {
              const inputEl = $('input[name="gasu1_kochi_haikansetsubi_nashi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          // gasu2_kochi_haikansetsubi_nashi: {
          //   warning: () => {
          //     const inputEl = $('input[name="gasu2_kochi_haikansetsubi_nashi"]')
          //     return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
          //   }
          // },
          // M007-08 - OK
          kanryojikeijo_kozoto_umusentaku: {
            warning: () => {
              const inputEl = $('input[name="kanryojikeijo_kozoto_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shikichi_tokibomenseki: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true
          },
          shikichi_kenchiku_kakunin_menseki: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          kyoyobubun_kyoyo_bubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="kyoyobubun_kyoyo_bubun"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kyoyobubun_hani: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_kyoyo_bubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kyoyobubun_hani"]').html()
            }

          },
          kyoyobubun_kanri_kiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_kyoyo_bubun"]')
              return $(inputEl[0]).is(':checked') &&  !$('td[name="kyoyobubun_kanri_kiyaku"]').html()
            }

          },
          kyoyobubun_kubun_sentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_kyoyo_bubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kyoyobubun_kubun_sentaku"]').html()
            }

          },
          kyoyobubun_mochibunwariai_jorei: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_kyoyo_bubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kyoyobubun_mochibunwariai_jorei"]').html()
            }

          },
          kyoyobubun_kubun_kisai: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_kubun_sentaku"]')
              return $(inputEl[1]).is(':checked') && !$('td[name="kyoyobubun_kubun_kisai"]').html()
            }

          },
          yotoseigen_yotoseigen: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="yotoseigen_yotoseigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          yotoseigen_seigen_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="yotoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('div[name="yotoseigen_seigen_naiyo"]').html()
            }

          },
          yotoseigen_kanrikiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="yotoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="yotoseigen_kanrikiyaku"]').html()
            }

          },
          yotoseigen_shiyosaisoku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="yotoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="yotoseigen_shiyosaisoku"]').html()
            }

          },
          pettoseigen_yotoseigen: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="pettoseigen_yotoseigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          pettoseigen_seigen_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="pettoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('div[name="pettoseigen_seigen_naiyo"]').html()
            }

          },
          pettoseigen_kanrikiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="pettoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="pettoseigen_kanrikiyaku"]').html()
            }

          },
          pettoseigen_shiyosaisoku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="pettoseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="pettoseigen_shiyosaisoku"]').html()
            }

          },
          furoringuseigen_yotoseigen: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="pettoseigen_yotoseigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          furoringuseigen_seigen_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="furoringuseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="furoringuseigen_seigen_naiyo"]').html()
            }

          },
          furoringuseigen_kanrikiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="furoringuseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="furoringuseigen_kanrikiyaku"]').html()
            }

          },
          furoringuseigen_shiyosaisoku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="furoringuseigen_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="furoringuseigen_shiyosaisoku"]').html()
            }

          },
          gakkishiyo_yotoseigen: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="gakkishiyo_yotoseigen"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          gakkishiyo_seigen_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="gakkishiyo_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('div[name="gakkishiyo_seigen_naiyo"]').html()
            }

          },
          gakkishiyo_kanrikiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="gakkishiyo_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="gakkishiyo_kanrikiyaku"]').html()
            }

          },
          gakkishiyo_shiyosaisoku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="gakkishiyo_yotoseigen"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="gakkishiyo_shiyosaisoku"]').html()
            }

          },
          hosoku_kanrikiyaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          hosoku_shiyosaisoku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          barukoni_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          barukoni_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="barukoni_kizokusaki_umusentaku"]').html()
            }
          },
          barukoni_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="barukoni_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          madonado_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          madonado_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="madonado_kizokusaki_umusentaku"]').html()
            }

          },
          madonado_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="madonado_senyoshiyoryo_kizokusaki_kubun"]').html()
            }

          },
          senyotei_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          senyotei_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="senyotei_kizokusaki_umusentaku"]').html()
            }

          },
          senyotei_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyotei_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="senyotei_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          rufubarukoni_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="torankurumu_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          rufubarukoni_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="torankurumu_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="rufubarukoni_kizokusaki_umusentaku"]').html()
            }
          },
          rufubarukoni_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="rufubarukoni_kizokusaki_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="rufubarukoni_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          torankurumu_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="torankurumu_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          torankurumu_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="torankurumu_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="torankurumu_kizokusaki_umusentaku"]').html()
            }
          },
          torankurumu_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="torankurumu_kizokusaki_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="torankurumu_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          chushajo_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="chushajo_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          chushajo_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="chushajo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="chushajo_kizokusaki_umusentaku"]').html()
            }
          },
          chushajo_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="chushajo_kizokusaki_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="chushajo_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          churinjo_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="churinjo_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          churinjo_kizokusaki_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="churinjo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="churinjo_kizokusaki_umusentaku"]').html()
            }
          },
          churinjo_senyoshiyoryo_kizokusaki_kubun: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="churinjo_kizokusaki_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="churinjo_senyoshiyoryo_kizokusaki_kubun"]').html()
            }
          },
          fuzuisenyo_barukoni_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          fuzuisenyo_madonado_naiyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          genmenkiyaku_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="genmenkiyaku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },

          shuzentsumitatekin_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },

          shuzentsumitatekin_kanrikiyaku_joreimei: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_kanrikiyaku_joreimei"]').html()
            }
          },

          shuzentsumitatekin_kingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_kingaku"]').html()
            }
          },

          shuzentsumitatekin_shuzen_tsumitatekin_nengappi: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_shuzen_tsumitatekin_nengappi"]').html()
            }
          },

          shuzentsumitatekin_taino_umu: {
            patterns:['jrb-03', 'jrb-04'],
            warning: false
          },

          shuzentsumitatekin_tainokingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_taino_umu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_tainokingaku"]').html()
            }
          },

          shuzentsumitatekin_taino_nengappi: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_taino_umu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_taino_nengappi"]').html()
            }

          },

          shuzentsumitatekin_tsumitategaku_kingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_tsumitategaku_kingaku"]').html()
            }

          },

          shuzentsumitatekin_tsumitategaku_nengappi: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_tsumitategaku_nengappi"]').html()
            }

          },

          shuzentsumitatekin_tsumitategaku_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: false
          },

          shuzentsumitatekin_tsumitategaku_tainogaku_kingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_tsumitategaku_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_tsumitategaku_tainogaku_kingaku"]').html()
            }
          },

          shuzentsumitatekin_tsumitategaku_nengappi2: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shuzentsumitatekin_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shuzentsumitatekin_tsumitategaku_nengappi2"]').html()
            }
          },
          kanrihi_kingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true
          },
          kanrihi_tainoumu: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="kanrihi_tainoumu"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kanrihi_tainokingaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kanrihi_tainoumu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kanrihi_tainokingaku"]').html()
            }
          },
          kanrihi_taino_nengappi: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kanrihi_tainoumu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kanrihi_taino_nengappi"]').html()
            }
          },
          kanrihi_taino_johokaiji_umu: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="kanrihi_taino_johokaiji_umu"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kanrihi_taino_johokaiji_tainogaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kanrihi_taino_johokaiji_umu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kanrihi_taino_johokaiji_tainogaku"]').html()
            }

          },
          kanrihi_taino_johokaiji_taino_nengappi: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kanrihi_taino_johokaiji_umu"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kanrihi_taino_johokaiji_taino_nengappi"]').html()
            }

          },
          kanrikumiai_meisho: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          kanri_keitai: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="kanri_keitai"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl[2]).is(':checked')
            }
          },
          kanriitakusaki_meisho: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          kanriitakusaki_tenwabango: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          // kanriitakusaki_tenwabango2: {
          //   patterns:['jrb-03', 'jrb-04'],
          //   warning: true

          // },
          // kanriitakusaki_tenwabango3: {
          //   patterns:['jrb-03', 'jrb-04'],
          //   warning: true
          // },
          kanriitakusaki_shozai: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          kanriitakusaki_manshonkanritekiseikaho_toroku_bango: {
            patterns:['jrb-03', 'jrb-04'],
            warning: true

          },
          kyoyobubun_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="kyoyobubun_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kyoyobubun_jisshijokyo: {
            patterns:['jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kyoyobubun_umusentaku"]')
              if($(inputEl[0]).is(':checked') && !$('div[name="kyoyobubun_jisshijokyo"]').html()) {
                $('td[name="kyoyobubun_jisshijokyo"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }

          },
          senyububun_umusentaku: {
            patterns:['jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="senyububun_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          senyububun_jisshijokyo: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="senyububun_umusentaku"]')
              if($(inputEl[0]).is(':checked') && !$('div[name="senyububun_jisshijokyo"]').html()) {
                $('td[name="senyububun_jisshijokyo"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          jokyochosa_gaito_umu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="jokyochosa_gaito_umu"]')
              const inputEl1 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl1[0]).is(':checked')
            }

          },
          jokyochosa_jisshi_umu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const dependInputEl = $('input[name="jokyochosa_gaito_umu"]')
              const inputEl = $('input[name="jokyochosa_jisshi_umu"]')
              return dependInputEl.length && $(dependInputEl[0]).is(':checked') && !inputEl.is(':checked')
            }

          },
          tatemono_ijihozen_gaitokubun: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="tatemono_ijihozen_gaitokubun"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          kakunin_shinseisho_hozonumu1: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="tatemono_ijihozen_gaitokubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kakunin_shinseisho_hozonumu1"]').html()
            }
          },
          kakuninzumisho_hozonumu2: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="tatemono_ijihozen_gaitokubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kakuninzumisho_hozonumu2"]').html()
            }
          },
          kensazumisho_hozonumu3: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="tatemono_ijihozen_gaitokubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kensazumisho_hozonumu3"]').html()
            }
          },
          zokaichiku_sentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl2 = $('input[name="tatemono_ijihozen_gaitokubun"]')
              const inputEl = $('input[name="zokaichiku_sentaku"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kakunin_shinseisho_hozonumu4: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="zokaichiku_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kakunin_shinseisho_hozonumu4"]').html()
            }
          },
          kakuninzumisho_hozonumu5: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="zokaichiku_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kakuninzumisho_hozonumu5"]').html()
            }
          },
          kensazumisho_hozonumu6: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="zokaichiku_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kensazumisho_hozonumu6"]').html()
            }
          },
          tatemono_jokyochosa_jisshi_jutakudearu_baai: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl2 = $('input[name="tatemono_ijihozen_gaitokubun"]')
              const inputEl = $('input[name="tatemono_jokyochosa_jisshi_jutakudearu_baai"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tatemono_jokyochosa_hokokusho_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="tatemono_jokyochosa_jisshi_jutakudearu_baai"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="tatemono_jokyochosa_hokokusho_hozonumu"]').html()
            }

          },
          kenchiku_kijunhodai_12jo_sentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl2 = $('input[name="tatemono_ijihozen_gaitokubun"]')
              const inputEl = $('input[name="kenchiku_kijunhodai_12jo_sentaku"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          teikichosa_teikihokokusho_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kenchiku_kijunhodai_12jo_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="teikichosa_teikihokokusho_hozonumu"]').html()
            }

          },
          kizonjutaku_seino_hyoka_sentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl2 = $('input[name="tatemono_ijihozen_gaitokubun"]')
              const inputEl = $('input[name="kizonjutaku_seino_hyoka_sentaku"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          kizonjutaku_seino_hyokasho_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kizonjutaku_seino_hyoka_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kizonjutaku_seino_hyokasho_hozonumu"]').html()
            }
          },
          shinchiku_koji_chaku_tatemonodearubaai_kubun: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl2 = $('input[name="tatemono_ijihozen_gaitokubun"]')
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          kizonjutaku_seinohyokasho_umu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kizonjutaku_seinohyokasho_umu"]').html()
            }

          },
          taishinshindan_kekka_hokokusho_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="taishinshindan_kekka_hokokusho_hozonumu"]').html()
            }

          },
          shintaishinkijun_tekigosei_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="shintaishinkijun_tekigosei_hozonumu"]').html()
            }

          },
          kashihoken_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="kashihoken_hozonumu"]').html()
            }

          },
          taishinkijuntekigoshomeish_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="taishinkijuntekigoshomeish_hozonumu"]').html()
            }

          },
          sonohoka_hozonumu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="shinchiku_koji_chaku_tatemonodearubaai_kubun"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="sonohoka_hozonumu"]').html()
            }

          },
          kakuninzumisho_umusentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: false
          },
          kensazumisho_umusentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: false
          },
          kakuninzumisho_nengappi: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kakuninzumisho_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && $('td[name="kakuninzumisho_nengappi"]').html() === '年  月  日'
            }
          },
          kakuninzumisho_bango: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kakuninzumisho_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$('td[name="kakuninzumisho_bango"]').html()
            }

          },
          kensazumisho_nengappi: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kensazumisho_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && ($('td[name="kensazumisho_nengappi"]').html() === '年  月  日')
            }

          },
          kensazumisho_bango: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="kensazumisho_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$('td[name="kensazumisho_bango"]').html()
            }

          },
          jutakuseinohyoka_uketa_shinchiku_sentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="jutakuseinohyoka_uketa_shinchiku_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }

          },
          sekkeijutaku_seino_hyokasho_umu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="jutakuseinohyoka_uketa_shinchiku_sentaku"]')
              const inputEl1 = $('input[name="sekkeijutaku_seino_hyokasho_umu"]')
              return $(inputEl[0]).is(':checked') && !$(inputEl1[0]).is(':checked') && !$(inputEl1[1]).is(':checked')
            }

          },
          kensetsujutaku_seino_hyokasho_umu: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning:  () => {
              const inputEl = $('input[name="jutakuseinohyoka_uketa_shinchiku_sentaku"]')
              const inputEl1 = $('input[name="kensetsujutaku_seino_hyokasho_umu"]')
              return $(inputEl[0]).is(':checked') && !$(inputEl1[0]).is(':checked') && !$(inputEl1[1]).is(':checked')
            }
          },
          ishiwatashiyo_chosa_umu_sentaku: {
            patterns:['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="ishiwatashiyo_chosa_umu_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          zoseitakuchi_kuiki_sentaku: {
            warning: () => {
              const inputEl = $('input[name="zoseitakuchi_kuiki_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          doshasaigai_kuiki_sentaku: {
            warning: () => {
              const inputEl = $('input[name="doshasaigai_kuiki_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tsunami_kuiki_sentaku: {
            warning: () => {
              const inputEl = $('input[name="tsunami_kuiki_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hazadomappu_umu_kozui: {
            warning: () => {
              const inputEl = $('input[name="hazadomappu_umu_kozui"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hazadomappu_umu_usuishussui: {
            warning: () => {
              const inputEl = $('input[name="hazadomappu_umu_usuishussui"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hazadomappu_umu_takashio: {
            warning: () => {
              const inputEl = $('input[name="hazadomappu_umu_takashio"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          // Array
          senyoshiyoken: {
            patterns: ['jrb-03', 'jrb-04'],
            elements: [
              {
                umusentaku: {
                  warning: (idx) => {
                    const inputEl1 = $('td[name="meisho"]')
                    const inputEl2 = $('input[name="umusentaku"]')
                    return $(inputEl1[idx]).html() && !$(inputEl2[idx * 2]).is(':checked')
                  }
                },
                kizokusaki_umusentaku: {
                  warning: (idx) => {
                    const inputEl1 = $('td[name="meisho"]')
                    const inputEl2 = $('input[name="umusentaku"]')
                    const inputEl3 = $('input[name="kizokusaki_umusentaku"]')
                    return $(inputEl1[idx]).html() && $(inputEl2[idx * 2]).is(':checked') && !$(inputEl3[idx * 2]).is(':checked')
                  }
                },
                senyoshiyoryo_kizokusaki_kubun: {
                  warning: (idx) => {
                    const inputEl1 = $('td[name="meisho"]')
                    const inputEl2 = $('input[name="kizokusaki_umusentaku"]')
                    const inputEl3 = $('input[name="senyoshiyoryo_kizokusaki_kubun"]')
                    return $(inputEl1[idx]).html() && $(inputEl2[idx * 2]).is(':checked') && !$(inputEl3[idx * 2]).is(':checked')
                  }
                }
              }
            ]
          },
          // M007-09 - OK
          baibaidaikin: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: true
          },
          uchishohizei_sotogaku: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="shohizei_hyoji"]')
              return ($(inputEl).is(':checked') && !$('td[name="uchishohizei_sotogaku"]').html())
            }
          },
          kingaku1: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: true
          },
          kingaku2: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const checkboxEl = $('input[name="hikiwatashiji_hiwari2"]')
              return checkboxEl.is(':checked') && !$('td[name="kingaku2"]').html()
            }
          },
          kingaku3: {
            patterns: ['jrb-03', 'jrb-04'],
            warning: true
          },
          // M007-10 OK
          tetsukekaijo_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="tetsukekaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          tetsukekaijo_nengappi: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="tetsukekaijo_umusentaku"]')
              return ($(inputEl[0]).is(':checked') && $('td[name="tetsukekaijo_nengappi"]').html() === '年  月  日')
            }
          },
          messhitsu_sonsho_kaijo_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="messhitsu_sonsho_kaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          yushiriyo_tokuyaku_kaijo_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="yushiriyo_tokuyaku_kaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          yushiriyo_tokuyaku_kaijo_nengappi: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="yushiriyo_tokuyaku_kaijo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && $('td[name="yushiriyo_tokuyaku_kaijo_nengappi"]').html() === '年  月  日'
            }
          },
          jotoshodaku_tokuyaku_kaijo_umusentaku: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="jotoshodaku_tokuyaku_kaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          jotoshodaku_tokuyaku_kaijo_nengappi: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="jotoshodaku_tokuyaku_kaijo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && $('td[name="jotoshodaku_tokuyaku_kaijo_nengappi"]').html() === '年  月  日'
            }
          },
          keiyakufutekigo_shuhoseikyu_kaijo_umusentaku: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl = $('input[name="keiyakufutekigo_shuhoseikyu_kaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          keiyakuihan_kaijo_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="keiyakuihan_kaijo_umusentaku"]')
              const inputEl2 = $('input[name="ikashasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked')
            }
          },
          // M007-11 OK
          iyakukin_sentaku: {
            warning: () => {
              const inputEl = $('input[name="iyakukin_sentaku"]')
              const inputEl1 = $('input[name="iyakukin_setsumei_shasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl1[0]).is(':checked')
            }
          },
          // M007-12 OK
          tetsukekin_hozensochi_gaiyo_sentaku: {
            warning: () => {
              const inputEl = $('input[name="tetsukekin_hozensochi_gaiyo_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hozensochi_gaiyo_kojirukadoka_sentaku: {
            warning: () => {
              const inputEl = $('input[name="tetsukekin_hozensochi_gaiyo_sentaku"]')
              return $(inputEl[0]).is(':checked')
             && !$('td[name="hozensochi_gaiyo_kojirukadoka_sentaku"]').html()
            }
          },
          kojinai_bukkenjotai_sentaku: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_gaiyo_kojirukadoka_sentaku"]')
              return $(inputEl[0]).is(':checked')
             && !$('td[name="kojinai_bukkenjotai_sentaku"]').html()
            }
          },
          kojiru_bukkenjotai_sentaku: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_gaiyo_kojirukadoka_sentaku"]')
              return $(inputEl[1]).is(':checked')
             && !$('td[name="kojiru_bukkenjotai_sentaku"]').html()
            }
          },
          kojiru_hozenhoshiki_sentaku: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_gaiyo_kojirukadoka_sentaku"]')
              return $(inputEl[1]).is(':checked')
             && !$('td[name="kojiru_hozenhoshiki_sentaku"]').html()
            }
          },
          kojiru_hozenkikan: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_gaiyo_kojirukadoka_sentaku"]')
              return $(inputEl[1]).is(':checked')
             && !$('div[name="kojiru_hozenkikan"]').html()
            }
          },
          // M007-13 OK
          hozensochi_kojirukadoka_sentaku: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_kojirukadoka_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          hozensochi_kojiru_kikan: {
            warning: () => {
              const inputEl = $('input[name="hozensochi_kojirukadoka_sentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="hozensochi_kojiru_kikan"]').html()
            }
          },
          // M007-14 OK
          assen_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_kinyukikan: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              if($(inputEl[0]).is(':checked') && !$('div[name="assenyu1_kinyukikan1"]').html() && !$(inputEl1[0]).is(':checked')) {
                $('td[name="assenyu1_kinyukikan1"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
              if($(inputEl[0]).is(':checked') && !$('div[name="assenyu1_kinyukikan"]').html() && !$(inputEl1[0]).is(':checked')) {
                $('td[name="assenyu1_kinyukikan"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          assenyu1_kingaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              const inputEl = $('input[name="assen_umusentaku"]')
              return ($(inputEl[0]).is(':checked') && (!$('td[name="assenyu1_kingaku"]').html() || this.arrText.includes($('td[name="assenyu1_kingaku"]').html()))) && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_hoshoryo: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return ($(inputEl[0]).is(':checked') && (!$('td[name="assenyu1_hoshoryo"]').html() || this.arrText.includes($('td[name="assenyu1_hoshoryo"]').html()))) && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_ronjimu_tesuryo: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[0]).is(':checked') && (!$('td[name="assenyu1_ronjimu_tesuryo"]').html() || this.arrText.includes($('td[name="assenyu1_ronjimu_tesuryo"]').html())) && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_hensaihoho: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              if($(inputEl[0]).is(':checked') && !$('td[name="assenyu1_hensaihoho"]').html() && !$(inputEl1[0]).is(':checked')) {
                $('td[name="assenyu1_hensaihoho"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
              // return $(inputEl[0]).is(':checked') && !$('td[name="assenyu1_hensaihoho"]').html() && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_shodakushonin_shutokukijitsu: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              if ($(inputEl[0]).is(':checked') && ($('.assenyu1_shodakushonin_shutokukijitsu').find('span[name="assenyu1_shodakushonin_shutokukijitsu"]').html() === '年  月  日') && !$(inputEl1[0]).is(':checked')) {
                $('.assenyu1_shodakushonin_shutokukijitsu').css({'background-color': 'rgb(255 224 146 / 60%)'})
              } else {
                $('.assenyu1_shodakushonin_shutokukijitsu').css({'background-color': 'transparent'})
              }
              if($(inputEl[0]).is(':checked') && (($('td[name="assenyu1_shodakushonin_shutokukijitsu"]').html() === '年  月  日')  && !$(inputEl1[0]).is(':checked'))) {
                $('td[name="assenyu1_shodakushonin_shutokukijitsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          assenyu1_kinriwariai: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="assenyu1_kinriwariai"]').html() && !$(inputEl1[0]).is(':checked')
            }
          },
          assenyu1_kariire_kikan_nen: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="assenyu1_kariire_kikan_nen"]').html() && !$(inputEl1[0]).is(':checked')
            }
          },
          assenmu1_kinyukikan: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              if($(inputEl[1]).is(':checked') && !$('div[name="assenmu1_kinyukikan1"]').html() && !$(inputEl1[0]).is(':checked')) {
                $('td[name="assenmu1_kinyukikan1"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          assenmu1_kingaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[1]).is(':checked') && (!$('td[name="assenmu1_kingaku"]').html() || this.arrText.includes($('td[name="assenmu1_kingaku"]').html())) && !$(inputEl1[0]).is(':checked')
            }
          },
          assenmu1_shodakushonin_shutokukijitsu: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              if($(inputEl[1]).is(':checked') && (($('td[name="assenmu1_shodakushonin_shutokukijitsu"]').html() === '年  月  日') && !$(inputEl1[0]).is(':checked'))) {
                $('td[name="assenmu1_shodakushonin_shutokukijitsu"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
              if ($(inputEl[1]).is(':checked') && ($('.assenmu1_shodakushonin_shutokukijitsu').find('span[name="assenmu1_shodakushonin_shutokukijitsu"]').html() === '年  月  日') && !$(inputEl1[0]).is(':checked')) {
                $('.assenmu1_shodakushonin_shutokukijitsu').css({'background-color': 'rgb(255 224 146 / 60%)'})
              } else {
                $('.assenmu1_shodakushonin_shutokukijitsu').css({'background-color': 'transparent'})
              }
            }
          },
          assenmu1_kinriwariai: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[1]).is(':checked') && !$('td[name="assenmu1_kinriwariai"]').html() && !$(inputEl1[0]).is(':checked')
            }
          },
          assenmu1_kariire_kikan_nen: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="assen_umusentaku"]')
              const inputEl1 = $('input[name="kinsen_taishaku_assen_shasen_hiku"]')
              return $(inputEl[1]).is(':checked') && !$('td[name="assenmu1_kariire_kikan_nen"]').html() && !$(inputEl1[0]).is(':checked')
            }
          },
          // M007-15 OK
          futekigo_sekinin_rikosochi_gaiyo_sentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="futekigo_sekinin_rikosochi_gaiyo_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          wappuhanbai_umusentaku: {
            patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="wappuhanbai_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          baibaidaikin_seisan_umusentaku: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl = $('input[name="baibaidaikin_seisan_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          seisan_taishotochi_hani: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl2 = $('input[name="baibaidaikin_seisan_umusentaku"]')
              const inputEl = $('input[name="seisan_taishotochi_hani"]')
              return $(inputEl2[0]).is(':checked') && !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked') && !$(inputEl[2]).is(':checked')
            }
          },
          seisan_taishotochi_hani_nyuryoku: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl = $('input[name="seisan_taishotochi_hani"]')
              return $(inputEl[2]).is(':checked') && !$('td[name="seisan_taishotochi_hani_nyuryoku"]').html()
            }
          },
          seisan_kijun_menseki: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl = $('input[name="baibaidaikin_seisan_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="seisan_kijun_menseki"]').html()
            }
          },
          seisan_tanka: {
            patterns: ['jrb-01', 'jrb-02'],
            warning: () => {
              const inputEl = $('input[name="baibaidaikin_seisan_umusentaku"]')
              return $(inputEl[0]).is(':checked') && (!$('td[name="seisan_tanka"]').html() || this.arrText.includes($('td[name="seisan_tanka"]').html()))
            }
          },
          keiyaku_futekigo_shuhoseikyu: {
            patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
            warning: () => {
              const inputEl = $('input[name="keiyaku_futekigo_shuhoseikyu"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          }
          // M007-16
          // M007-17
          // M007-18
        },
        'jle':{ // OK
          kashinushi_jusho: {
            patterns: 'jle-01',
            warning: true
          },
          kashinushi_shimei: {
            patterns: 'jle-01',
            warning: true
          },
          kashinushi_tochishoyusha_idosentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="kashinushi_tochishoyusha_idosentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          riyu_sentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="riyu_sentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tochi_shozai: {
            patterns: 'jle-01',
            warning: () => {
              if(!$('div[name="tochi_shozai"]').html()) {
                $('td[name="tochi_shozai"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          tochi_chiban: {
            patterns: 'jle-01',
            warning: () => {
              if(!$('div[name="tochi_chiban"]').html()) {
                $('td[name="tochi_chiban"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          tochi_zumen_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="tochi_zumen_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tochi_chimoku1: {
            patterns: 'jle-01',
            warning: () => {
              return !$('td[name="tochi_chimoku1"]').html() && !$('td[name="tochi_chimoku2"]').html()
            }
          },
          keiyakunaiyo_shakuchishurui: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          shakuchi1_shakuchikubun: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              return +$(inputEl[0]).is(':checked') && !$('td[name="shakuchi1_shakuchikubun"]').html()
            }
          },
          shakuchi1_teikishakuchikenbunrui: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              const inputEl2 = $('input[name="shakuchi1_shakuchikubun"]')
              return +$(inputEl[0]).is(':checked') && +$(inputEl2[1]).is(':checked')
            && !$('td[name="shakuchi1_teikishakuchikenbunrui"]').html()
            }
          },
          shakuchi2_shakuchikenshurui_chijoken: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              const inputEl2 = $('input[name="shakuchi2_shakuchikenshurui_chijoken"]')
              const inputEl3 = $('input[name="shakuchi2_shakuchikenshurui_taishakuken"]')
              return $(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          shakuchi2_shakuchikenshurui_taishakuken: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              const inputEl2 = $('input[name="shakuchi2_shakuchikenshurui_chijoken"]')
              const inputEl3 = $('input[name="shakuchi2_shakuchikenshurui_taishakuken"]')
              return $(inputEl[1]).is(':checked') && !$(inputEl2[0]).is(':checked') && !$(inputEl3[0]).is(':checked')
            }
          },
          shakuchi2_kengoshurui_kubun: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakunaiyo_shakuchishurui"]')
              return $(inputEl[1]).is(':checked') && !$('td[name="shakuchi2_kengoshurui_kubun"]').html()
            }
          },
          kikan_kaishi_nengappi: {
            patterns: 'jle-01',
            warning: () => {
              return($('td[name="kikan_kaishi_nengappi"]').html() === '年  月  日～')
            }
          },
          kikan_shuryo_nengappi: {
            patterns: 'jle-01',
            warning: () => {
              return($('td[name="kikan_shuryo_nengappi"]').html() === '年  月  日')
            }
          },

          koshin_kahi: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="koshin_kahi"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          koshinryo_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="koshinryo_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          koshinryo_kingaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="koshinryo_umusentaku"]')
              if ($(inputEl[0]).is(':checked') && !$('td[name="koshinryo_kingaku"]').html()) {
                $('td[name="koshinryo_kingaku"]').css({'background-color': 'rgb(255 224 146 / 60%)'})
              }
            }
          },
          tokijiko_shakuchiken_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="tokijiko_shakuchiken_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tokijiko_tatemono_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="tokijiko_tatemono_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_shidofutan_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_shidofutan_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_joto_tentai_shodaku_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_joto_tentai_shodaku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_joto_tentai_shodakuryo_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_joto_tentai_shodakuryo_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_zokaichiku_shodaku_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_zokaichiku_shodaku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_zokaichiku_shodakuryo_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_zokaichiku_shodakuryo_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          keiyakusho_koseishoshoka: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="keiyakusho_koseishoshoka"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          chidai_kaitei_tokuyaku_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="chidai_kaitei_tokuyaku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          tatemono_torikowashi_tokuyaku_umusentaku: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="tatemono_torikowashi_tokuyaku_umusentaku"]')
              return !$(inputEl[0]).is(':checked') && !$(inputEl[1]).is(':checked')
            }
          },
          sonohoka_joto_tentai_shodakuryo: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_joto_tentai_shodakuryo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="sonohoka_joto_tentai_shodakuryo"]').html()
            }
          },
          sonohoka_zokaichiku_shodakuryo: {
            patterns: 'jle-01',
            warning: () => {
              const inputEl = $('input[name="sonohoka_zokaichiku_shodakuryo_umusentaku"]')
              return $(inputEl[0]).is(':checked') && !$('td[name="sonohoka_zokaichiku_shodakuryo"]').html()
            }
          },
          chidai_getsugaku: {
            patterns: 'jle-01',
            warning: () => {
              return !$('td[name="chidai_getsugaku"]').html() || this.arrText.includes($('td[name="chidai_getsugaku"]').html())
            }
          }
        }
      },
      templateDataOcr: {}
    }
  },
  mounted() {
    this.isShowComment = this.getStateShowComment
    // $('.preview-edit-side').css('height', `${window.innerHeight - 290}`)
    if(this.getShowZoomBar === true) {
      $('.zoom-show-search').css('padding-top', '14.5rem')
    //   $('.comment-preivew-frame').css('top', '185.4px')
    //   $('.comment-preivew-frame').css('height', `${window.innerHeight - 185}`)
    // } else {
    //   $('.comment-preivew-frame').css('height', `${window.innerHeight - 270}`)
    }
    $('.comment-preivew-frame').css('height', `${window.innerHeight - 270}`)
    const getElement = document.querySelectorAll('.vs-popup-primary')
    if(getElement) {
      getElement.forEach(element => {
        element.style.display = 'none'
      })
    }
    this.documentId = this.$store.getters.musubellDocumentId
    this.base64DocumentId = base64Url.encode(`MusubellDocumentType:${this.documentId}`)
    this.$store.dispatch(GET_SURVEY_LINKAGE, this.base64DocumentId)
    this.$store.commit(SET_STATE_SHOW_ZOOM_BAR, this.getShowZoomBar)
    PagingSeparation.init()
    this.loadLayout()
    this.addEventRoute()

    bus.$off('saveUseTemplate')
    bus.$on('saveUseTemplate', (data) => {
      if(data) {
        setTimeout(() => {
          this.loadLayout(data)
        }, 200)
      }
    })
  },
  created() {
    bus.$on('fillJusetsuPatternData', this.handleFillPatternData)
  },
  destroyed() {
    bus.$off('fillJusetsuPatternData', this.handleFillPatternData)
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    zoomValue() {
      if(this.zoomValue.toFixed(2) <= 1) {
        this.xPosition = 0
      }
    }
  },
  methods: {
    tickPart(partName) {
      console.log(partName)
    },
    handleShowHightlightInPage(idElement) {
      const elementData = document.getElementsByClassName(idElement)
      const element = elementData[0]
      if(element) {
        element.style.scrollMarginTop = '30px'
        element.scrollIntoView()
        window.scrollBy(0, -250)
      }
    },
    handleShowHightlightInPageIgnore(idElement) {
      const isIdGeneral1 = idJusetsuGeneral_l1.includes(idElement)
      if(isIdGeneral1) {
        idElement = idElement.substring(0, 7) +  (parseInt(idElement.substring(7)) - 1).toString()
      }

      const listRight = ['jtm-01-3', 'jtm-02-4']
      const listLeft = ['jtm-01-4', 'jtm-02-5']
      let left = null
      let right = null
      let zoomLeft = 0
      let zoomTop = 0
      if(listRight.includes(idElement)) {
        right = 378
      }
      if(listLeft.includes(idElement)) {
        left = 380
        const indexId = listLeft.indexOf(idElement)
        idElement = listRight[indexId]
      }
      const elementData = document.getElementsByClassName(idElement)
      const element = elementData[0]
      if(element) {
        element.style.scrollMarginTop = '30px'
        element.scrollIntoView()
        window.scrollBy(0, -100)
        if(this.currentTimeout) {
          clearTimeout(this.currentTimeout)
          $('.wrapper').remove()
        }
        this.currentTimeout = setTimeout(() => {
          $('.wrapper').remove()
        }, 10000)

        const zoomLevel = Math.round(this.zoomValue * 100)


        switch(zoomLevel) {
        case 50:
          zoomLeft = 24
          zoomTop = 20
          break
        case 75:
          zoomLeft = 9
          zoomTop = 9
          break
        case 125:
          zoomLeft = -4
          zoomTop = -4
          break
        case 150:
          zoomLeft = -6
          zoomTop = -6
          break
        case 175:
          zoomLeft = -8
          zoomTop = -8
          break
        case 200:
          zoomLeft = -10
          zoomTop = -10
          break
        default: 
          break
        }

        const type = {
          name: 'jusetsu',
          left,
          right,
          zoomLeft,
          zoomTop
        }

        Highlight.highlightElement(idElement, type)
      }
    },
    loadLayout(hasOCR) {
      const musubellDocumentGlobalIdBase64 = this.$route.params.documentGlobalId
      const musubellDocumentGlobalId = base64Url.decode(musubellDocumentGlobalIdBase64)
      const musubellDocumentId = musubellDocumentGlobalId.split(':')[1]
      this.$store.dispatch(GET_KEIYAKU_BY_DOCUMENT_ID, musubellDocumentId).then(() => {
        
        const { prevRoute, code, template, pattern } = this.$store.getters
        const jusetsuHtml = template.jusetsu
        const keiyaku = _.cloneDeep(this.$store.getters.keiyaku)
        const jusetsu = _.cloneDeep(this.$store.getters.keiyaku.jusetsu)
        const layoutUpdate = _.get(prevRoute, 'meta.layoutUpdate')
        if(hasOCR === 1) {
          this.handleFillDataFromTemplate(jusetsu, code, pattern)
          this.$store.commit(SET_DATA_SAVE_STATUS, true)
        } else {
          // const isHtmlNotLoadedYet = Object.values(jusetsuHtml).every(x => x === null || x === '')
          // if (isHtmlNotLoadedYet || editMode.bsc || editMode.bpm || editMode.bes) {
          // if (this.handleCheckPattern(jusetsu, pattern) === 1) {
          //   jusetsu.jes.tochi1_biko = jusetsu.jes.tochi1_biko
          //   jusetsu.jes.shikitikentochi_biko_matsubi_ikayohaku_hyoji = jusetsu.jes.tochi1_biko_matsubi_ikayohaku_hyoji
          //   jusetsu.jes.shikitikentochi_biko_numbering = jusetsu.jes.tochi1_biko_numbering
          //   jusetsu.jes.tochi1_biko_matsubi_ikayohaku_hyoji = jusetsu.jes.shikitikentochi_biko_matsubi_ikayohaku_hyoji
          //   jusetsu.jes.tochi1_biko_numbering = jusetsu.jes.shikitikentochi_biko_numbering
          // }
          if (this.handleCheckPattern(jusetsu, pattern) === 2) {
            // jusetsu.jes.tochi1_biko = ''
            jusetsu.jes.shikitikentochi_biko_matsubi_ikayohaku_hyoji = jusetsu.jes.tochi1_biko_matsubi_ikayohaku_hyoji
            jusetsu.jes.shikitikentochi_biko_numbering = jusetsu.jes.tochi1_biko_numbering
            // jusetsu.jes.tochi1_biko_matsubi_ikayohaku_hyoji = true
            // jusetsu.jes.tochi1_biko_numbering = true
            jusetsu.jes.tochi2 = []
            jusetsu.jes.shikikentochi_tochi2_gokeifudekazu = null
            jusetsu.jes.shikikentochi_tochi2_gokeimenseki = null
            jusetsu.jes.shikikentochi_tochi2_tanihyoji = null
            jusetsu.jes.tochi1 = []
            jusetsu.jes.tochi1_gokeifudekazu = null
            jusetsu.jes.tochi1_gokeimenseki = null
            jusetsu.jes.tochi1_tanihyoji = null
          }
          if (this.handleCheckPattern(jusetsu, pattern) === 3) {
            jusetsu.jes.shikitikentochi_biko_matsubi_ikayohaku_hyoji = true
            jusetsu.jes.shikitikentochi_biko_numbering = true
            jusetsu.jes.tochi1_gokeifudekazu = null
            jusetsu.jes.tochi1_gokeimenseki = null
            jusetsu.jes.tochi1_tanihyoji = null
            jusetsu.jes.shikikentochi_tochi2_gokeifudekazu = null
            jusetsu.jes.shikikentochi_tochi2_gokeimenseki = null
            jusetsu.jes.shikikentochi_tochi2_tanihyoji = null
          }

          if (this.handleCheckPattern(jusetsu, pattern) === 4) {
            jusetsu.jes.shikitikentochi_biko_matsubi_ikayohaku_hyoji = true
            jusetsu.jes.shikitikentochi_biko_numbering = true
            jusetsu.jes.tochi1_gokeifudekazu = null
            jusetsu.jes.tochi1_gokeimenseki = null
            jusetsu.jes.tochi1_tanihyoji = null
            jusetsu.jes.shikikentochi_tochi2_gokeifudekazu = null
            jusetsu.jes.shikikentochi_tochi2_gokeimenseki = null
          }
          jusetsu.jrb = { ...jusetsu.jrb,
            ...jusetsu.jrb07_04,
            ...jusetsu.jrb07_05,
            ...jusetsu.jrb07_06,
            ...jusetsu.jrb07_07,
            ...jusetsu.jrb07_08,
            ...jusetsu.jrb07_09,
            ...jusetsu.jrb07_10,
            ...jusetsu.jrb07_11,
            ...jusetsu.jrb07_12,
            ...jusetsu.jrb07_13,
            ...jusetsu.jrb07_14,
            ...jusetsu.jrb07_15,
            ...jusetsu.jrb07_16,
            ...jusetsu.jrb07_17,
            ...jusetsu.jrb07_18}
          this.$store.dispatch(GET_JUSETSU_TEMPLATE, {
            code, jusetsu
          }).then(jusetsuHtml => {
            this.updateLayout(jusetsuHtml)
          })

          return
          // }
        }
        if (JUSETSU.includes(layoutUpdate)) {
          let htmlPart = null
          const partPreview = {}
          const jusetsuPattern = pattern.jusetsu
          const jusetsuData = keiyaku.jusetsu

          if (layoutUpdate === JES || layoutUpdate === JSE) {
            partPreview.partType = `${jusetsuPattern[JES]}_${jusetsuPattern[JSE]}`
            partPreview.partData = {}
            partPreview.partData[JES] = keiyaku.jusetsu[JES]
            partPreview.partData[JSE] = keiyaku.jusetsu[JSE]
            partPreview.htmlPart = `${JES}_${JSE}`
            partPreview.code = code
            htmlPart = `${JES}_${JSE}`
          } else if (layoutUpdate === JRB) {
            jusetsuData.jrb =  {...jusetsuData.jrb, ...jusetsuData.jrb07_04, ...jusetsuData.jrb07_05, ...jusetsuData.jrb07_06, ...jusetsuData.jrb07_07, ...jusetsuData.jrb07_08, ...jusetsuData.jrb07_09, ...jusetsuData.jrb07_10, ...jusetsuData.jrb07_11, ...jusetsuData.jrb07_12, ...jusetsuData.jrb07_13, ...jusetsuData.jrb07_14, ...jusetsuData.jrb07_15, ...jusetsuData.jrb07_16, ...jusetsuData.jrb07_17, ...jusetsuData.jrb07_18}
            partPreview.partType = jusetsuPattern[layoutUpdate]
            partPreview.partData = keiyaku.jusetsu[layoutUpdate]
            partPreview.htmlPart = layoutUpdate
            partPreview.code = code
            htmlPart = layoutUpdate
          } else if (layoutUpdate === JTM) {
            jusetsuData.jtm = {...jusetsuData.jtm}
            partPreview.partType = jusetsuPattern[layoutUpdate]
            partPreview.partData = keiyaku.jusetsu[layoutUpdate]
            partPreview.htmlPart = layoutUpdate
            partPreview.code = code
            htmlPart = layoutUpdate
          } else {
            partPreview.partType = jusetsuPattern[layoutUpdate]
            partPreview.partData = keiyaku.jusetsu[layoutUpdate]
            partPreview.htmlPart = layoutUpdate
            htmlPart = layoutUpdate
            partPreview.code = code
          }
          this.$store.dispatch(GET_PART_JUSETSU_TEMPLATE, partPreview)
            .then(partHtml => {
              jusetsuHtml[htmlPart] = partHtml.html
              return jusetsuHtml
            }).then(jusetsuHtml => this.updateLayout(jusetsuHtml))

          return
        }

        setTimeout(() => {
          this.updateLayout(jusetsuHtml)
        }, 100)
      
      })
    },

    handleCheckPattern(jusetsu, pattern) {
      if (_.get(jusetsu, 'jes.jesPatternFrom', false)) {
        const besFrom = jusetsu.jes.besPatternFrom
        const besTo  = pattern.baikei.bes
        const jesFrom = jusetsu.jes.jesPatternFrom
        const jesTo  = pattern.jusetsu.jes
        if ((besFrom === 'bes-01' || besFrom === 'bes-02' || besFrom === 'bes-03') && besTo === 'bes-09') {
          return 1
        }
        if ((besFrom === 'bes-09') && (besTo === 'bes-01' || besTo === 'bes-02' || besTo === 'bes-03')) {
          return 1
        }
        if ((besFrom === 'bes-04' || besFrom === 'bes-05' || besFrom === 'bes-06' || besFrom === 'bes-07') && besTo === 'bes-09') {
          return 2
        }
        if ((besFrom === 'bes-09') && (besTo === 'bes-04' || besTo === 'bes-05' || besTo === 'bes-06' || besTo === 'bes-07')) {
          return 2
        }
        if ((jesFrom === 'jes-03') && (jesTo === 'jes-04')) {
          return 3
        }
        if ((jesFrom === 'jes-04') && (jesTo === 'jes-03')) {
          return 3
        }
        if((jesFrom === 'jes-01' || jesFrom === 'jes-02') && jesTo === 'jes-03') {
          return 4
        }
        if(jesFrom === 'jes-03' && (jesFrom === 'jes-01' || jesFrom === 'jes-02')) {
          return 4
        }
      }
      return 0
    },

    makeHighlight() {
      const { pattern } = this.$store.getters
      Object.keys(this.templateValidation).forEach(groupPattern => {
        Object.keys(this.templateValidation[groupPattern]).forEach(key => {
          if (!pattern.jusetsu[groupPattern] || !Array.isArray(this.templateValidation[groupPattern][key].patterns) ||
            this.templateValidation[groupPattern][key].patterns.includes(pattern.jusetsu[groupPattern])) {
            // CHECK WARNING
            //ARRAY
            if(this.templateValidation[groupPattern][key].elements) {
              this.templateValidation[groupPattern][key].elements.forEach((child, idx) => {
                Object.keys(child).forEach(childKey => {
                  if (typeof (this.templateValidation[groupPattern][key].elements[idx][childKey].warning) === 'function') {
                    let fieldEls = $(`td[name='${childKey}']`)
                    if (!fieldEls.length) {
                      // CHECK SPAN
                      fieldEls = $(`span[name='${childKey}']`)
                    }
                    if (!fieldEls.length) {
                      // CHECK DIV
                      fieldEls = $(`div[name='${childKey}']`)
                    }
                    if (fieldEls.length) {
                      for(let i = 0; i < fieldEls.length; i++) {
                        if (this.templateValidation[groupPattern][key].elements[idx][childKey].warning(i)) {
                          const fieldEl = $(fieldEls[i])
                          if ((fieldEl.prop('tagName').toLowerCase() === 'span' || fieldEl.prop('tagName').toLowerCase() === 'div') && $(fieldEl.parents('td')[0]).length > 0) {
                            $(fieldEl.parents('td')[0]).css({'background-color': 'rgb(255 224 146 / 60%)'})
                          } else {
                            fieldEl.css({'background-color': 'rgb(255 224 146 / 60%)'})
                          }
                        }
                      }
                    } else {
                      const numberOfInputs = 2
                      fieldEls = $(`input[name='${childKey}']`)
                      for(let i = 0; i < fieldEls.length / numberOfInputs; i++) {
                        if (this.templateValidation[groupPattern][key].elements[idx][childKey].warning(i)) {
                          const ele = $(fieldEls[i * numberOfInputs])
                          const ele2 = $(fieldEls[(i * numberOfInputs) + 1])
                          $(ele).css({'box-shadow': '0px 0px 0px 1px rgb(255 197 54)'})
                          $(ele2).css({'box-shadow': '0px 0px 0px 1px rgb(255 197 54)'})
                        }
                      }
                    }
                  } else if (typeof (this.templateValidation[groupPattern][key].elements[idx][childKey].warning) !== 'function') {
                    const fieldEls = $(`td[name='${childKey}']`)
                    for(let i = 0; i < fieldEls.length; i++) {
                      const fieldEl = fieldEls[i]
                      if (fieldEl) {
                        const fieldElChild = $(fieldEl)
                        const fieldVal = fieldElChild.html()
                        if (fieldElChild.length && (fieldVal === null || fieldVal === undefined || fieldVal === '' || fieldVal === false || fieldVal === ' ' || this.arrText.includes(fieldVal))) {
                        // MAKE COLOR WARNING
                          if ((fieldElChild.prop('tagName').toLowerCase() === 'span' || fieldElChild.prop('tagName').toLowerCase() === 'div') && $(fieldEl.parents('td')[0]).length > 0) {
                            $(fieldElChild.parents('td')[0]).css({'background-color': 'rgb(255 224 146 / 60%)'})
                          } else {
                            fieldElChild.css({'background-color': 'rgb(255 224 146 / 60%)'})
                          }
                        }
                      }
                    }
                  }
                })
              })
            } else {
              //Function
              // eslint-disable-next-line
              if (typeof this.templateValidation[groupPattern][key].warning === 'function' && this.templateValidation[groupPattern][key].warning()) {
                // MAKE COLOR WARNING
                let fieldEl = $(`td[name='${key}']`)
                if (!fieldEl.length) {
                  // CHECK SPAN
                  fieldEl = $(`span[name='${key}']`)
                }
                if (!fieldEl.length) {
                  // CHECK DIV
                  fieldEl = $(`div[name='${key}']`)
                }
                if (fieldEl.length) {
                  // MAKE COLOR WARNING
                  if (fieldEl.prop('tagName').toLowerCase() === 'span' || fieldEl.prop('tagName').toLowerCase() === 'div') {
                    $(fieldEl.parents('td')[0]).css({'background-color': 'rgb(255 224 146 / 60%)'})
                  } else {
                    fieldEl.css({'background-color': 'rgb(255 224 146 / 60%)'})
                  }
                } else {
                  let ischecked = false
                  const field = $(`input[name='${key}']`)
                  if(field.length) {
                    $.each(field, (index, ele) => {
                      if($(ele).is(':checked') === true) {
                        ischecked = true
                      }
                    })
                    if(ischecked === false) {
                      $.each(field, (index, ele) => {
                        $(ele).css({'box-shadow': '0px 0px 0px 1px rgb(255 197 54)'})
                      })
                    }
                  }
                }
              } else if (typeof this.templateValidation[groupPattern][key].warning !== 'function') {
                let fieldEl = $(`td[name='${key}']`)
                if (!fieldEl.length) {
                  // CHECK SPAN
                  fieldEl = $(`span[name='${key}']`)
                }
                if (!fieldEl.length) {
                  // CHECK DIV
                  fieldEl = $(`div[name='${key}']`)
                }
                const fieldVal = fieldEl.html()
                if (fieldEl.length && (fieldVal === null || fieldVal === undefined || fieldVal === '' || fieldVal === false || fieldVal === ' ' || this.arrText.includes(fieldVal))) {
                  // MAKE COLOR WARNING
                  if (fieldEl.prop('tagName').toLowerCase() === 'span' || fieldEl.prop('tagName').toLowerCase() === 'div') {
                    $(fieldEl.parents('td')[0]).css({'background-color': 'rgb(255 224 146 / 60%)'})
                  } else {
                    fieldEl.css({'background-color': 'rgb(255 224 146 / 60%)'})
                  }
                } else {
                  let ischecked = false
                  const field = $(`input[name='${key}]`)
                  if(field.length) {
                    $.each(field, (index, ele) => {
                      if($(ele).is(':checked') === true) {
                        ischecked = true
                      }
                    })
                    if(ischecked === false) {
                      $.each(field, (index, ele) => {
                        $(ele).css({'boder-color': 'rgb(255 224 146 / 60%)'})
                      })
                    }
                  }
                }
              }
            }
          }
        })
      })
    },

    updateLayout(jusetsuHtml, scrollTo) {
      this.showSpinner(true)
      const layoutPreviewElm = $('#layout-preview #jusetsu')
      layoutPreviewElm.empty()
      const { pattern } = this.$store.getters
      $(`<div id="meta-data" jusetsuNo="jusetsu-${  pattern.jusetsuNo > 9 ? '' : '0'  }${  pattern.jusetsuNo  }" style="display: none"></div>`).appendTo(layoutPreviewElm)
      const pageHtml = []
      for(const html of JUSETSU_HTML) {
        if(jusetsuHtml[html]) {
          pageHtml.push(jusetsuHtml[html])
        }
      }

      $(pageHtml.join('')).hide().appendTo(layoutPreviewElm).fadeIn(100)
      $('#layout-preview').css({'border': 'none'})

      setTimeout(() => {
        const separationPages = layoutPreviewElm.find('.pdf-page')
        for (let i = 0; i < separationPages.length; i++) {
          PagingSeparation.separation(separationPages[i])
        }
        PagingSeparation.addPageNumber()
        PagingSeparation.addCataloguePaginate()
        if (this.lastUpdateAt) {
          PagingSeparation.addTimestamp('A4', moment(this.lastUpdateAt).format('YYYY/MM/DD  HH:mm:ss'))
        }
        PagingSeparation.addTitleForJusetsu('A4')
        this.layoutPreviewElm = layoutPreviewElm
        const breakPages = layoutPreviewElm.find('.pdf-page')
        for (let i = 0; i < breakPages.length; i++) {
          PagingSeparation.setTagBreakPage(breakPages[i])
        }
        this.showSpinner(false)
        this.$root.$emit('layout_loaded')
        this.highlight()

        if (scrollTo) {
          window.scrollTo(0, scrollTo)
        }
      }, 200)

      const editMode = this.$store.getters.editMode
      let jyusetsuEditMode = false
      Object.keys(editMode).forEach(key => {
        if (key !== 'bes' && key !== 'bpm' && key !== 'bsc') {
          if (editMode[key] === true) {
            jyusetsuEditMode = true
          }
        }
      })
      if (jyusetsuEditMode) {
        this.makeHighlight()
      }
    },
    updateBreakPage(breakKey) {
      // const scrollTo = $(document).scrollTop()
      const { template, keiyaku } = this.$store.getters
      const jusetsuHtml = template.jusetsu
      let jusetsuOwnPart = null
      const keys = ['jtm', 'jtc', 'jes', 'jse', 'jrb', 'jle']
      for (const key of keys) {
        if(breakKey && breakKey.includes(key)) {
          jusetsuOwnPart = key
          break
        }
      }
      let jrbTemp = {}
      if(keiyaku.jusetsu && keiyaku.jusetsu.jrb === undefined) {
        Object.keys(keiyaku.jusetsu).forEach((key) => {
          Object.keys(keiyaku.jusetsu[key]).forEach((subkey) => {
            if(subkey) {
              if(subkey.startsWith('break_page_jrb')) {
                jrbTemp = {...jrbTemp, ...keiyaku.jusetsu[key]}
              }
            }
          })
        })
        keiyaku.jusetsu.jrb = {...jrbTemp, ...keiyaku.jusetsu.jrb}
      }
      let partData = keiyaku.jusetsu[jusetsuOwnPart]
      const breakAfter = partData ? partData[breakKey] : false
      if (!partData) {
        partData = {}
      }
      partData[breakKey] = !breakAfter
      const action = PART_TO_ACTION[jusetsuOwnPart]
      this.$store.dispatch(action, partData)
        .then(() => {
          let updateHtml = null
          let htmlPart = null
          if(jusetsuOwnPart.startsWith(JES) || jusetsuOwnPart.startsWith(JSE)) {
            updateHtml = jusetsuHtml.jes_jse
            htmlPart = `${JES}_${JSE}`
          } else if (jusetsuOwnPart.startsWith(JRB)) {
            updateHtml = jusetsuHtml.jrb
            htmlPart = JRB
          } else if (jusetsuOwnPart.startsWith(JTM)) {
            updateHtml = jusetsuHtml.jtm
            htmlPart = JTM
          } else {
            updateHtml = jusetsuHtml[jusetsuOwnPart]
            htmlPart = jusetsuOwnPart
          }

          const $updateHtml = $(updateHtml)
          $updateHtml.find(`.pdf-block[pdf-break-after-key=${breakKey}]`).attr('pdf-break-after-always', !breakAfter)

          const partHtml = {
            htmlPart,
            html: $updateHtml[0].outerHTML
          }
          return this.$store.dispatch(SAVE_PART_JUSETSU_TEMPLATE, partHtml)
        })
        .then(() => {
          this.$store.commit(SET_DATA_SAVE_STATUS, true)
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            const { template } = this.$store.getters
            this.updateLayout(template.jusetsu)
          })
        })
    },
    addEventRoute() {
      const _self = this
      const { copyDocumentGlobalId } = this.$route.params
      $('body').on('click', '.part-pdf-select', function (e) {
        if ($(e.target).parents('.tag-break-page').length > 0) {
          return
        }
        if (copyDocumentGlobalId) {
          e.preventDefault()
          return false
        } else {
          const route = $(e.currentTarget).attr('route')
          _self.routeToPart(route)
        }
      })

      $('body').on('click', '.tag-break-page', function (e) {
        if (copyDocumentGlobalId) {
          e.preventDefault()
          return false
        } else {
          const $elm = $(e.target).parents('.tag-break-page')
          const breakKey = $elm.attr('pdf-break-after-key')
          _self.updateBreakPage(breakKey)
        }
      })
    },
    routeToPart(url) {
      if (!url) {
        return
      }
      this.$router.push(`${url}`)
    },
    showSpinner(show = true) {
      const appLoading = document.getElementById('loading-bg')
      if (appLoading) {
        if (show) {
          $('body').css({'overflow-y': 'hidden'})
          appLoading.style.display = 'block'
          this.spinnerTimer = setTimeout(() => {
            appLoading.style.display = 'none'
            $('body').css({'overflow-y': 'unset'})
          }, 30000)
        } else {
          clearTimeout(this.spinnerTimer)
          appLoading.style.display = 'none'
          $('body').css({'overflow-y': 'unset'})
        }
      }
    },
    handleFillDataFromTemplate(jusetsu, code, pattern) {
      const { getSelectLandType } = this.$store.getters
      const besPattern = _.get(this.$store.getters.pattern, 'baikei.bes', null)
      const bes = _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bes', {})) === null ? {} : _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bes', {}))
      if(this.getUseTemplate) {
        const data = this.getUseTemplate.getCertificateRegistryForDocument
        if(data) {
          if(data.land.lands && data.land.lands.length > 0) {
            this.dataTochiInputs = data.land.lands
          } else {
            this.dataTochiInputs = [
              {
                address: '',
                chibanChi: null,
                chibanBan: null,
                chimoku: '',
                chiseki: null,
                siteRight: '',
                numerator: null,
                denominator: null
              }
            ]
          }
          const data_jes =  {
            tochi1: this.dataTochiInputs.map(item => {
              const obj = Object.assign({}, {
                shozai: this.handleTrimMaxLength(item.address, 26),
                chibanmae: this.handleTrimMaxLength(item.chibanChi, 5),
                chibanato: this.handleTrimMaxLength(item.chibanBan, 5),
                chimoku1: this.handleFillDataWithSelect(item.chimoku, 'select', 301), //select
                chimoku2: this.handleFillDataWithSelect(this.handleTrimMaxLength(item.chimoku, 5), 'input', 301),
                chiseki: this.handleTrimMaxLength(this.formatNumber(item.chiseki), this.handleMaxLength(8, this.formatNumber(item.chiseki))),
                mochibun1: this.handleTrimMaxLength(item.numerator, 5),
                mochibun2: this.handleTrimMaxLength(item.denominator, 5)
              })
              return obj
            }),
            tochi1_gokeifudekazu: data.land.totalCount,
            tochi1_gokeimenseki: this.handleTrimMaxLength(this.formatNumber(data.land.totalArea), 26),
            tatemono_shozai: this.handleTrimMaxLength(data.address, 26),
            tatemono_chibanmae: this.handleTrimMaxLength(data.chibanChi, 5),
            tatemono_chibanato: this.handleTrimMaxLength(data.chibanBan, 5),
            tatemono_yaokubango: this.handleTrimMaxLength(data.kaokuBangou, 9),
            tatemono_shurui1: this.handleFillDataWithSelect(data.propertyType, 'select', 302), //select 
            tatemono_shurui2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.propertyType, 20), 'input', 302), //input 
            tatemono_kozo_zou1: this.handleFillDataWithSelect(data.structureZou, 'select', 303), //select 
            tatemono_kozo_zou2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.structureZou, 40), 'input', 303), //input 
            tatemono_kozo_fuki1: this.handleFillDataWithSelect(data.structureShu, 'select', 305), //select 
            tatemono_kozo_fuki2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.structureShu, 40), 'input', 305), //input 
            tatemono_kozo_kaidate1: this.handleFillDataWithSelect(data.structureKaidate, 'select', 307), //select 
            tatemono_kozo_kaidate2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.structureKaidate, 30), 'input', 307), //input 
            tatemono_yukamenseki_1kai: this.handleTrimMaxLength(this.formatNumber(data.firstFloorArea), this.handleMaxLength(10, this.formatNumber(data.firstFloorArea))),
            tatemono_yukamenseki_2kai: this.handleTrimMaxLength(this.formatNumber(data.secondFloorArea), this.handleMaxLength(10, this.formatNumber(data.secondFloorArea))),
            tatemono_yukamenseki_kaisu: this.handleTrimMaxLength(data.etcFloorName, 5),
            tatemono_yukamenseki_sonohoka: this.handleTrimMaxLength(data.etcFloorArea, 22),
            tatemono_yukamenseki_gokei: this.checkStringTotal(data.totalFloorArea, 14),
            tatemono_zokaichikujiki: data.extensionRenovationType, //radio 
            tatemonomeisho: this.handleTrimMaxLength(data.buildingName, 28),
            tatemonomeisho_mune: this.handleTrimMaxLength(data.buildingTou, 5),
            tatemonomeisho_kai: this.handleTrimMaxLength(data.buildingFloor, 5),
            tatemonomeisho_goshitsu: this.handleTrimMaxLength(this.formatInteger(data.roomNumber, false), 6),
            tatemono_biko: this.handleTrimMaxLengthArea(data.note, 1000),
            ittiotatemono_shozai: this.handleTrimMaxLength(data.address, 35),
            ittiotatemono_chibanmae: this.handleTrimMaxLength(data.chibanChi, 5),
            ittiotatemono_chibanato: this.handleTrimMaxLength(data.chibanBan, 5),
            ittiotatemono_kozo_zou1: this.handleFillDataWithSelect(data.structureZou, 'select', 304), //select
            ittiotatemono_kozo_zou2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.structureZou, 28), 'input', 304), //input
            ittiotatemono_kozo_fuki1: this.handleFillDataWithSelect(data.structureShu, 'select', 306), //select 
            ittiotatemono_kozo_fuki2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.structureShu, 28), 'input', 306), //select 
            ittiotatemono_kozo_kaidate1: this.handleTrimMaxLength(data.structureKaidate, 12),
            ittiotatemono_kozo_kaidate2: this.handleTrimMaxLength(data.structureTouya, 10),
            ittiotatemono_nobetokomenseki: this.handleTrimMaxLength(this.formatNumber(data.totalFloorArea), this.handleMaxLength(13, this.formatNumber(data.totalFloorArea))),
            senyububun_yaokubango: this.handleTrimMaxLength(data.kaokuBangou, 15),
            senyububun_meisho: this.handleTrimMaxLength(data.propertyName, 13),
            senyububun_shurui1: this.handleFillDataWithSelect(data.propertyType, 'select', 308), //select 
            senyububun_shurui2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.propertyType, 20), 'input', 308), //select
            senyububun_kozo1: this.handleFillDataWithSelect(data.propertyStructure, 'select', 309), //select
            senyububun_kozo2: this.handleFillDataWithSelect(this.handleTrimMaxLength(data.propertyStructure, 20), 'input', 309), //input
            senyububun_kozo3: this.handleTrimMaxLength(this.formatInteger(data.propertyFloor), 2),
            senyububun_yukamenseki_tokibogaibubun: this.handleTrimMaxLength(data.propertyAreaFloor, 5),
            senyububun_yukamenseki: this.handleTrimMaxLength(this.formatNumber(data.propertyArea), this.handleMaxLength(13, this.formatNumber(data.propertyArea))),
            tatemono_kenchikujikiu: this.handleFormatDateJES(data.constructionNengou, data.constructionYear, data.constructionMonth),
            tatemono_kenchikujikiu_checkbox: false,
            tatemono_zokaichikujikan: this.handleFormatDateJES(data.extensionRenovationNengou, data.extensionRenovationYear, data.extensionRenovationMonth),
            tatemono_zokaichikujikan_checkbox: false,
            senyububun_kenchikujiki: this.handleFormatDateJES(data.constructionNengou, data.constructionYear, data.constructionMonth),
            senyububun_kenchikujiki_checkbox: false,
            shikikentochi: this.dataTochiInputs.map(item => {
              const obj = Object.assign({}, {
                shozai: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(item.address, 36) : '',
                chibanmae: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(item.chibanChi, 5) : '',
                chibanato: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(item.chibanBan, 5) : '',
                chimoku1: pattern.jusetsu.jes === 'jes-03' ? this.handleFillDataWithSelect(item.chimoku, 'select', 301) : '', //select
                chimoku2: pattern.jusetsu.jes === 'jes-03' ? this.handleFillDataWithSelect(this.handleTrimMaxLength(item.chimoku, 5), 'input', 301) : '',
                chiseki: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(this.formatNumber(item.chiseki), this.handleMaxLength(8, this.formatNumber(item.chiseki))) : '',
                shikiken_shurui: pattern.jusetsu.jes === 'jes-03' ? this.handleFillDataWithSelect(item.siteRight, 'select', 310) : '', //select 
                wariai1: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(item.numerator, 9) : '',
                wariai2: pattern.jusetsu.jes === 'jes-03' ? this.handleTrimMaxLength(item.denominator, 9) : ''
              })
              return obj
            }),
            tochi2: this.dataTochiInputs.map(item => {
              const obj = Object.assign({}, {
                shozai: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(item.address, 26) : '',
                chibanmae: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(item.chibanChi, 5) : null,
                chibanato: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(item.chibanBan, 5) : '',
                chimoku1: pattern.jusetsu.jes === 'jes-04' ? this.handleFillDataWithSelect(item.chimoku, 'select', 301) : '', //select
                chimoku2: pattern.jusetsu.jes === 'jes-04' ? this.handleFillDataWithSelect(this.handleTrimMaxLength(item.chimoku, 5), 'input', 301) : '',
                chiseki: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(this.formatNumber(item.chiseki), this.handleMaxLength(8, this.formatNumber(item.chiseki))) : null,
                mochibun1: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(item.numerator, 9) : null,
                mochibun2: pattern.jusetsu.jes === 'jes-04' ? this.handleTrimMaxLength(item.denominator, 9) : null
              })
              return obj
            }),
            shikikentochi_tochi2_gokeifudekazu: data.land.totalCount,
            shikikentochi_tochi2_gokeimenseki: this.handleTrimMaxLength(this.formatNumber(data.land.totalArea), 26),
            shikitikentochi_biko: this.handleTrimMaxLengthArea(data.land.note, 1000),
            kubunshoyutatemono_biko: this.handleTrimMaxLengthArea(data.note, 1000)
          }
          if(besPattern === 'bes-01' || besPattern === 'bes-02' || besPattern === 'bes-03') {
            bes.tochi = data_jes.tochi1
            bes.tochi_gokeifudekazu = data_jes.tochi1_gokeifudekazu
            bes.tochi_gokeimenseki = data_jes.tochi1_gokeimenseki
          }
          if(besPattern === 'bes-04' || besPattern === 'bes-05' || besPattern === 'bes-06') {
            bes.shakuchiken_tochi = data_jes.tochi1
          }
          if(besPattern === 'bes-07') {
            bes.teiki_shakuchiken_tochi = data_jes.tochi1
            bes.teikishakuchi_menseki = data_jes.tochi1_gokeimenseki
          }
          if(besPattern === 'bes-02' || besPattern === 'bes-03' || besPattern === 'bes-04' || besPattern === 'bes-05' || besPattern === 'bes-06' || besPattern === 'bes-07') {
            bes.tatemono_shozai1 = data_jes.tatemono_shozai
            bes.tatemono_shozai2 = data_jes.tatemono_chibanmae
            bes.tatemono_shozai3 = data_jes.tatemono_chibanato
            bes.tatemono_kaokubango = data_jes.tatemono_yaokubango
            bes.tatemono_shurui1 = data_jes.tatemono_shurui1
            bes.tatemono_shurui2 = data_jes.tatemono_shurui2
            bes.tatemono_kozo_zou1 = data_jes.tatemono_kozo_zou1
            bes.tatemono_kozo_fuki1 = data_jes.tatemono_kozo_fuki1
            bes.tatemono_kozo_kaidate1 = data_jes.tatemono_kozo_kaidate1
            bes.tatemono_kai1 = data_jes.tatemono_yukamenseki_1kai
            bes.tatemono_kai2 = data_jes.tatemono_yukamenseki_2kai
            bes.sonohoka_menseki = data_jes.tatemono_yukamenseki_kaisu
            bes.sonohoka = data_jes.tatemono_yukamenseki_sonohoka
            bes.tatemono_gokei = data_jes.tatemono_yukamenseki_gokei
          }
          if(besPattern === 'bes-08' || besPattern === 'bes-10') {
            bes.ittiotatemono_meisho = data_jes.tatemonomeisho
            // bes.ittiotatemono_meishotosu = data_jes.tatemonomeisho_mune
            // bes.ittiotatemono_meisho_kaisu = data_jes.tatemonomeisho_kai
            // bes.ittiotatemono_meisho_heya_bango = data_jes.tatemonomeisho_goshitsu
            bes.ittiotatemono_shozai1 = data_jes.ittiotatemono_shozai
            bes.ittiotatemono_shozai2 = data_jes.ittiotatemono_chibanmae
            bes.ittiotatemono_shozai3 = data_jes.ittiotatemono_chibanato
            bes.ittiotatemono_kozo_zou1 = data_jes.ittiotatemono_kozo_zou1
            bes.ittiotatemono_kozo_fuki1 = data_jes.ittiotatemono_kozo_fuki1
            bes.ittiotatemono_kozo_kaidate1 = data_jes.ittiotatemono_kozo_kaidate1
            bes.ittiotatemono_kozo_kaidate2 = data_jes.ittiotatemono_kozo_kaidate2
            bes.ittiotatemono_nobetokomenseki = data_jes.ittiotatemono_nobetokomenseki
            bes.senyububun_kaokubango = data_jes.senyububun_yaokubango
            bes.senyububun_meisho = data_jes.senyububun_meisho
            bes.senyububun_shurui1 = data_jes.senyububun_shurui1
            bes.senyububun_kozo1 = data_jes.senyububun_kozo1
            bes.senyububun_kozo2 = data_jes.senyububun_kozo2
            bes.senyububun_kozo3 = data_jes.senyububun_kozo3
            bes.senyububun_kaibubun = data_jes.senyububun_yukamenseki_tokibogaibubun
            bes.senyububun_yukamenseki = data_jes.senyububun_yukamenseki 
            bes.shikiken_mokutekitochi = data_jes.shikikentochi.map(item => {
              return {
                shozai: item.shozai,
                chibanmae: item.chibanmae,
                chibanato: item.chibanato,
                chimoku1: item.chimoku1,
                chimoku2: item.chimoku2,
                chiseki: item.chiseki,
                shurui: item.shikiken_shurui,
                shikichiken_wariai1: item.wariai1,
                shikichiken_wariai2: item.wariai2
              }
            })
            bes.shikikentochi_fudekazu = data_jes.shikikentochi_tochi2_gokeifudekazu
            bes.shikikentochi_menseki = data_jes.shikikentochi_tochi2_gokeimenseki
          }
          if(besPattern === 'bes-09') {
            bes.ittiotatemono_meisho = data_jes.tatemonomeisho
            // bes.ittiotatemono_meishotosu = data_jes.tatemonomeisho_mune
            // bes.ittiotatemono_meisho_kaisu = data_jes.tatemonomeisho_kai
            // bes.ittiotatemono_meisho_heya_bango = data_jes.tatemonomeisho_goshitsu
            bes.ittiotatemono_shozai1 = data_jes.ittiotatemono_shozai
            bes.ittiotatemono_shozai2 = data_jes.ittiotatemono_chibanmae
            bes.ittiotatemono_shozai3 = data_jes.ittiotatemono_chibanato
            bes.ittiotatemono_kozo_zou1 = data_jes.ittiotatemono_kozo_zou1
            bes.ittiotatemono_kozo_fuki1 = data_jes.ittiotatemono_kozo_fuki1
            bes.ittiotatemono_kozo_kaidate1 = data_jes.ittiotatemono_kozo_kaidate1
            bes.ittiotatemono_kozo_kaidate2 = data_jes.ittiotatemono_kozo_kaidate2
            bes.ittiotatemono_nobetokomenseki = data_jes.ittiotatemono_nobetokomenseki
            bes.senyububun_kaokubango = data_jes.senyububun_yaokubango
            bes.senyububun_meisho = data_jes.senyububun_meisho
            bes.senyububun_shurui1 = data_jes.senyububun_shurui1
            bes.senyububun_shurui2 = data_jes.senyububun_shurui2
            bes.senyububun_kozo1 = data_jes.senyububun_kozo1
            bes.senyububun_kozo2 = data_jes.senyububun_kozo2
            bes.senyububun_kozo3 = data_jes.senyububun_kozo3
            bes.senyububun_kaibubun = data_jes.senyububun_yukamenseki_tokibogaibubun
            bes.senyububun_yukamenseki = data_jes.senyububun_yukamenseki 
            bes.tochi = data_jes.tochi2
            bes.tochi_gokeifudekazu = data_jes.shikikentochi_tochi2_gokeifudekazu
            bes.tochi_gokeimenseki = data_jes.shikikentochi_tochi2_gokeimenseki
          }
          const data_jrb04 = this.handleFillDataJRB04(data, getSelectLandType)
          this.$store.dispatch(SAVE_JES, data_jes).then(() => {
            this.$store.dispatch(SAVE_EDIT_MODE, {'jes': true})
            this.$store.dispatch(SAVE_BES, bes)
            this.$store.dispatch(SAVE_JRB_M007_04, data_jrb04).then(
              () => {
                this.$store.dispatch(SAVE_EDIT_MODE, {'jrb07_04': true})
              })
          })
          jusetsu.jes = { ...jusetsu.jes, ...data_jes}
          jusetsu.jrb07_04 = { ...jusetsu.jrb07_04, ...data_jrb04}
          jusetsu.jrb = { ...jusetsu.jrb,
            ...jusetsu.jrb07_04,
            ...jusetsu.jrb07_05,
            ...jusetsu.jrb07_06,
            ...jusetsu.jrb07_07,
            ...jusetsu.jrb07_08,
            ...jusetsu.jrb07_09,
            ...jusetsu.jrb07_10,
            ...jusetsu.jrb07_11,
            ...jusetsu.jrb07_12,
            ...jusetsu.jrb07_13,
            ...jusetsu.jrb07_14,
            ...jusetsu.jrb07_15,
            ...jusetsu.jrb07_16,
            ...jusetsu.jrb07_17,
            ...jusetsu.jrb07_18}
          this.$store.dispatch(GET_JUSETSU_TEMPLATE, {
            code, jusetsu
          }).then(jusetsuHtml => {
            this.updateLayout(jusetsuHtml)
            setTimeout(() => {
              this.$toasted.info('登記事項証明書（不動産）を保存しました')
              this.$store.dispatch(SAVE_KEIYAKU)
            }, 100)
          }).catch(() => {
            this.$toasted.error('登記事項証明書（不動産）情報保存にエラー発生しました')
          })
        }
      }
    },
    handleFillDataJRB04(data, type) {
      if(type === 'H') {
        const data_tokijiko_taisho1_koku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionKouku : null
        const data_tokijiko_taisho1_otsuku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionOtsuku : null
        const data_tokijiko_taisho2_koku_tokinaiyo = data.registrationRecord.building ? data.registrationRecord.building.rightsDivisionKouku : null
        const data_tokijiko_taisho2_otsuku_tokinaiyo = data.registrationRecord.building ? data.registrationRecord.building.rightsDivisionOtsuku : null
        const dataH_jrb04 = {
          tokijiko_taisho1_shomeinengappi: data.registrationRecord ? this.handleFormatDate(data.registrationRecord.land) : null,
          tokijiko_taisho1_shomeinengappi_checkbox: true,
          tokijiko_taisho1_koku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_koku_tokinaiyo, 1000),
          tokijiko_taisho1_otsuku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_otsuku_tokinaiyo, 1000),
          tokijiko_taisho2_shomeinengappi: data.registrationRecord ? this.handleFormatDate(data.registrationRecord.building) : null,
          tokijiko_taisho2_shomeinengappi_checkbox: true,
          tokijiko_taisho2_koku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho2_koku_tokinaiyo, 1000),
          tokijiko_taisho2_otsuku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho2_otsuku_tokinaiyo, 1000)
        }
        return dataH_jrb04
      } else if(type === 'M') {
        const data_tokijiko_taisho1_koku_tokinaiyo = data.registrationRecord.building ? data.registrationRecord.building.rightsDivisionKouku : null
        const data_tokijiko_taisho1_otsuku_tokinaiyo = data.registrationRecord.building ? data.registrationRecord.building.rightsDivisionOtsuku : null
        const data_tokijiko_taisho2_koku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionKouku : null
        const data_tokijiko_taisho2_otsuku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionOtsuku : null
        const dataM_jrb04 = {
          tokijiko_taisho1_shomeinengappi: data.registrationRecord ? this.handleFormatDate(data.registrationRecord.building) : null,
          tokijiko_taisho1_shomeinengappi_checkbox: true,
          tokijiko_taisho1_koku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_koku_tokinaiyo, 1000),
          tokijiko_taisho1_otsuku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_otsuku_tokinaiyo, 1000),
          tokijiko_taisho2_shomeinengappi: data.registrationRecord ? this.handleFormatDate(data.registrationRecord.land) : null,
          tokijiko_taisho2_shomeinengappi_checkbox: true,
          tokijiko_taisho2_koku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho2_koku_tokinaiyo, 1000),
          tokijiko_taisho2_otsuku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho2_otsuku_tokinaiyo, 1000)
        }
        return dataM_jrb04
      } else if(type === 'L') {
        const data_tokijiko_taisho1_koku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionKouku : null
        const data_tokijiko_taisho1_otsuku_tokinaiyo = data.registrationRecord.land ? data.registrationRecord.land.rightsDivisionOtsuku : null
        const dataL_jrb04 = {
          tokijiko_taisho1_shomeinengappi: data.registrationRecord ? this.handleFormatDate(data.registrationRecord.land) : null,
          tokijiko_taisho1_shomeinengappi_checkbox: true,
          tokijiko_taisho1_koku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_koku_tokinaiyo, 1000),
          tokijiko_taisho1_otsuku_tokinaiyo: this.handleTrimMaxLengthArea(data_tokijiko_taisho1_otsuku_tokinaiyo, 1000)
        }
        return dataL_jrb04
      }
    },

    async handleGetDataPattern1 (base64DocumentId) {
      return await MusubellAgentApi.getPropertyForDocumentJusetsuPattern1(base64DocumentId)
        .then((data) => {
          if(data) {
            const response = data.data.data.getPropertyForDocument
            console.log('handleGetDataPattern1', response)
            return response
          }
        })
    },
    async handleGetDataPattern2 (base64DocumentId) {
      console.log(base64DocumentId)
      return await MusubellAgentApi.getPropertyForDocumentJusetsuPattern2(base64DocumentId)
        .then((data) => {
          if(data) {
            const response = data.data.data.getPropertyForDocument
            console.log('handleGetDataPattern2', response)
            return response
          }
        })
    },
    async handleGetDataPattern3 (base64DocumentId) {
      return await MusubellAgentApi.getPropertyForDocumentJusetsuPattern3(base64DocumentId)
        .then((data) => {
          if(data) {
            const response = data.data.data.getPropertyForDocument
            console.log('handleGetDataPattern3', response)
            return response
          }
        })
    },
    async handleGetDataPattern4 (base64DocumentId) {
      return await MusubellAgentApi.getPropertyForDocumentJusetsuPattern4(base64DocumentId)
        .then((data) => {
          if(data) {
            const response = data.data.data.getPropertyForDocument
            console.log('handleGetDataPattern4', response)
            return response
          }
        })
    },

    // OCR jusetsu
    async fetchTemplateList(base64DocumentId) {
      let data = {}
      switch(this.jrbPattern) {
      case 'jrb-01':
        data = await this.handleGetDataPattern1(base64DocumentId)
        if(data) {
          this.handleFillDataFormByOcr(data)
        }
        break
      case 'jrb-02':
        data = await this.handleGetDataPattern2(base64DocumentId)
        if(data) {
          this.handleFillDataFormByOcr(data)
        }
        break
      case 'jrb-03':
        data = await this.handleGetDataPattern3(base64DocumentId)
        if(data) {
          this.handleFillDataFormByOcr(data)
        }
        break
      case 'jrb-04':
        data = await this.handleGetDataPattern4(base64DocumentId)
        if (data) {
          this.handleFillDataFormByOcr(data)
        }
        break
      default:
      }
      
    },

    handleFillPatternData() {
      this.documentId = this.$store.getters.musubellDocumentId
      this.base64DocumentId = base64Url.encode(`MusubellDocumentType:${this.documentId}`)
      this.fetchTemplateList(this.base64DocumentId)
    },

    isEmptyObject(obj) {
      return Object.keys(obj).length === 0
    },

    handleFillDataFormByOcr(data) {
      const musubellDocumentGlobalIdBase64 = this.$route.params.documentGlobalId
      const musubellDocumentGlobalId = base64Url.decode(musubellDocumentGlobalIdBase64)
      const musubellDocumentId = musubellDocumentGlobalId.split(':')[1]
      this.$store.dispatch(GET_KEIYAKU_BY_DOCUMENT_ID, musubellDocumentId).then(() => {
        const { code } = this.$store.getters
        const jusetsu = _.cloneDeep(this.$store.getters.keiyaku.jusetsu)
        const data_jes = this.handleMappingOcr(data, this.jrbPattern, 'jes')
        jusetsu.jes = { ...jusetsu.jes, ...data_jes}
        const data_jrb = this.handleMappingOcr(data, this.jrbPattern, 'jrb')
        jusetsu.jrb = {
          ...jusetsu.jrb,
          ...jusetsu.jrb07_04,
          ...jusetsu.jrb07_05,
          ...jusetsu.jrb07_06,
          ...jusetsu.jrb07_07,
          ...jusetsu.jrb07_08,
          ...jusetsu.jrb07_09,
          ...jusetsu.jrb07_10,
          ...jusetsu.jrb07_11,
          ...jusetsu.jrb07_12,
          ...jusetsu.jrb07_13,
          ...jusetsu.jrb07_14,
          ...jusetsu.jrb07_15,
          ...jusetsu.jrb07_16,
          ...jusetsu.jrb07_17,
          ...jusetsu.jrb07_18,
          ...data_jrb
        }
        const data_jle = this.handleMappingOcr(data, this.jrbPattern, 'jle')
        jusetsu.jle = {...jusetsu.jle, ...data_jle}
        const data_jse = this.handleMappingOcr(data, this.jrbPattern, 'jse')
        jusetsu.jse = {...jusetsu.jse, ...data_jse}
        const data_jtm = this.handleMappingOcr(data, this.jrbPattern, 'jtm')
        jusetsu.jtm = {...jusetsu.jtm, ...data_jtm}
        const jrbScreens = [{screen: 'jrb07_07', actionName: 'SAVE_JRB_M007_07'}, {screen: 'jrb07_05', actionName: 'SAVE_JRB_M007_05'}, {screen: 'jrb07_06', actionName: 'SAVE_JRB_M007_06'}, {screen: 'jrb07_08', actionName: 'SAVE_JRB_M007_08'}]
        jrbScreens.forEach((item) => {
          const jrbDataForScreen = this.handleMappingOcrJrb(data, this.jrbPattern, item.screen)
          if(!this.isEmptyObject(jrbDataForScreen)) {
            jusetsu[item.screen] = {...jusetsu[item.screen], ...jrbDataForScreen}
            jusetsu.jrb = {...jusetsu.jrb, ...jusetsu[item.screen]}
            this.$store.dispatch(item.actionName, jusetsu[item.screen]).then(
              () => {
                this.$store.dispatch(SAVE_EDIT_MODE, {[item.screen]: true})
              })
          }
        })
        // BES shared field
        const besPattern = _.get(this.$store.getters.pattern, 'baikei.bes', null)
        const bes = _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bes', {})) === null ? {} : _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bes', {}))
        if(besPattern === 'bes-02' || besPattern === 'bes-03' || besPattern === 'bes-04' || besPattern === 'bes-05' || besPattern === 'bes-06' || besPattern === 'bes-07') {
          bes.tatemono_kozo_zou1 = jusetsu.jes.tatemono_kozo_zou1
          bes.tatemono_kozo_zou2 = jusetsu.jes.tatemono_kozo_zou2
          bes.tatemono_kozo_fuki1 = jusetsu.jes.tatemono_kozo_fuki1
          bes.tatemono_kozo_fuki2 = jusetsu.jes.tatemono_kozo_fuki2
          bes.tatemono_kozo_kaidate1 = jusetsu.jes.tatemono_kozo_kaidate1
          bes.tatemono_kozo_kaidate2 = jusetsu.jes.tatemono_kozo_kaidate2
          bes.tatemono_gokei = jusetsu.jes.tatemono_yukamenseki_gokei
        }
        if(besPattern === 'bes-08' || besPattern === 'bes-10' || besPattern === 'bes-09') {
          bes.ittiotatemono_meisho = jusetsu.jes.tatemonomeisho
          bes.ittiotatemono_shozai1 = jusetsu.jes.ittiotatemono_shozai
          bes.ittiotatemono_shozai2 = jusetsu.jes.ittiotatemono_chibanmae
          bes.ittiotatemono_shozai3 = jusetsu.jes.ittiotatemono_chibanato
          bes.ittiotatemono_kozo_zou1 = jusetsu.jes.ittiotatemono_kozo_zou1
          bes.ittiotatemono_kozo_zou2 = jusetsu.jes.ittiotatemono_kozo_zou2
          bes.ittiotatemono_kozo_fuki1 = jusetsu.jes.ittiotatemono_kozo_fuki1
          bes.ittiotatemono_kozo_fuki2 = jusetsu.jes.ittiotatemono_kozo_fuki2
          bes.ittiotatemono_kozo_kaidate1 = jusetsu.jes.ittiotatemono_kozo_kaidate1
          bes.ittiotatemono_kozo_kaidate2 = jusetsu.jes.ittiotatemono_kozo_kaidate2
          bes.senyububun_kaokubango = jusetsu.jes.senyububun_yaokubango
          bes.senyububun_meisho = jusetsu.jes.senyububun_meisho
          bes.senyububun_shurui1 = jusetsu.jes.senyububun_shurui1
          bes.senyububun_shurui2 = jusetsu.jes.senyububun_shurui2
          bes.senyububun_kozo1 = jusetsu.jes.senyububun_kozo1
          bes.senyububun_kozo2 = jusetsu.jes.senyububun_kozo2
          bes.senyububun_kozo3 = jusetsu.jes.senyububun_kozo3
          bes.senyububun_kaibubun = jusetsu.jes.senyububun_yukamenseki_tokibogaibubun
          bes.senyububun_yukamenseki = jusetsu.jes.senyububun_yukamenseki 
        }
        if(!this.isEmptyObject(jusetsu.jes)) {
          this.$store.dispatch(SAVE_JES, jusetsu.jes).then(() => {
            this.$store.dispatch(SAVE_EDIT_MODE, {'jes': true})
            this.$store.dispatch(SAVE_BES, bes)
          })
        }
        if(!this.isEmptyObject(jusetsu.jrb)) {
          this.$store.dispatch(SAVE_JRB, jusetsu.jrb).then(() => {
          })
        }
        if(!this.isEmptyObject(jusetsu.jtm)) {
          this.$store.dispatch(SAVE_JTM, jusetsu.jtm).then(() => {
            this.$store.dispatch(SAVE_EDIT_MODE, {'jtm': true})
          })
        }
        if(!this.isEmptyObject(jusetsu.jse)) {
          this.$store.dispatch(SAVE_JSE, jusetsu.jse).then(() => {
            this.$store.dispatch(SAVE_EDIT_MODE, {'jse': true})
          })
        }
        if(!this.isEmptyObject(jusetsu.jle)) {
          this.$store.dispatch(SAVE_JLE, jusetsu.jle).then(() => {
            this.$store.dispatch(SAVE_EDIT_MODE, {'jle': true})
          })
        }
        this.$store.dispatch(GET_JUSETSU_TEMPLATE, {
          code, jusetsu
        }).then(jusetsuHtml => {
          this.updateLayout(jusetsuHtml)
          let breadcrumbs = this.$store.getters.breadcrumbs
          if(breadcrumbs.length > 1) {
            breadcrumbs = breadcrumbs.slice(1)
          }
          this.$store.dispatch(UPDATE_BREADCRUMB, breadcrumbs)
          setTimeout(() => {
            this.$toasted.info('物件調査データを反映しました。')
            this.$store.dispatch(SAVE_KEIYAKU)
          }, 100)
        }).catch(() => {
          this.$toasted.error('物件調査データの反映は失敗しました。')
        })
      })
        
    }

  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    zoomValue() {
      return this.$store.getters.getZoomValue
    },
    keiyakuId () {
      return this.$store.getters.keiyakuId
    },
    showDebug() {
      return !String(location.href).startsWith('https')
    },
    lastUpdateAt () {
      return this.$store.getters.lastUpdateAt
    },
    reduceButton: {
      get ()    { return this.$store.state.reduceButton }
    },
    getShowZoomBar() {
      return this.$store.getters.getShowZoomBar
    },
    getUseTemplate() {
      return this.$store.getters.getUseTemplate
    },
    jrbPattern() {
      return _.get(this.$store.getters.pattern, 'jusetsu.jrb', null)
    }
  },
  beforeDestroy() {
    $('body').off('click', '.part-pdf-select')
    $('body').off('click', '.tag-break-page')
  }
}

</script>
<style scoped>
.post-body{
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* Internet Explorer */
-khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
-webkit-user-select: none; /* Chrome, Safari, and Opera */
-webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}
#layout-preview {
  min-height: calc(100vh - 350px);
  min-width: 210mm;
  border: 1px solid #385d8a;
}
.preview-edit-side {
  overflow: scroll;
  /* height: 666px; */
  margin-top: 0.75rem;
}
.comment-preivew-frame {
  overflow: scroll;
  position: fixed;
  right: 16px;
  top: 272px;
}
.w-57 {
  width: 56%;
}
.w-61 {
  width: 61%;
}
.scrollbar {
  position: fixed;
  width: 46.8%;
}
.w-573 {
  width: 57.3%;
}
.scrollbar input {
  width: 100%;
}
</style>
